/* UPP redesign: product page behaviour (sections/upp-main-product.liquid).
   - option buttons -> variant: hidden id, ?variant= URL, price, availability, per-size prices,
     size label, spec rows, dimensions drawing, gallery slide, sticky bar, chair default count,
     lead time (in stock / made to order / sold text, delivery options and dates, variants[].lt)
   - gallery: scroll-snap track, arrows, thumbnails, counter, zoom dialog, external video on tap
   - add to cart: one /cart/add.js call (table + matching chairs when ticked); the theme's cart
     drawer opens through the same events theme.AjaxProduct fires (ajaxProduct:adding / :added /
     :addFailed), with the drawer section markup in the response
   - sticky add-to-cart bar (phones and desktop) once the main button has scrolled away
   - records the product for the theme's recently viewed section */
(function () {
  'use strict';

  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function Pdp(root) {
    this.root = root;
    var json = $(root, '[data-upp-pdp-json]');
    try { this.data = JSON.parse(json ? json.textContent : '{}'); } catch (e) { this.data = {}; }
    this.variants = this.data.variants || [];
    this.form = $(root, '[data-upp-form]');
    this.atc = $(root, '[data-upp-atc]');
    this.setTouched = false;
    var cur = $(root, '[data-upp-variant-id]');
    this.variant = this.findById(cur ? Number(cur.value) : 0) || this.variants[0];

    this.money = this.makeMoney();
    this.initOptions();
    this.initGallery();
    this.initDrawChips();
    if (this.variant) this.updateSize(this.variant); /* draws the chairs on first load */
    this.initSteppers();
    this.initSet();
    this.initSamples();
    if (this.variant) this.updateButtons();   /* labels, sticky bar price + struck price, also without a chair set */
    this.initForm();
    this.initBar();
    this.initSizeGuide();
    this.initCustomLinks();
    this.initStatus();
    this.recordRecent();
  }

  Pdp.prototype.makeMoney = function () {
    var cur = this.data.currency || 'USD';
    var fmt0, fmt2;
    try {
      fmt0 = new Intl.NumberFormat('en-US', { style: 'currency', currency: cur, minimumFractionDigits: 0, maximumFractionDigits: 0 });
      fmt2 = new Intl.NumberFormat('en-US', { style: 'currency', currency: cur, minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } catch (e) {
      return function (cents) { return '$' + (cents / 100).toFixed(2); };
    }
    return function (cents) { return cents % 100 === 0 ? fmt0.format(cents / 100) : fmt2.format(cents / 100); };
  };

  /* Units by country (snippets/upp-dim; data.metric from localization on the server): cm first
     outside the US / LR / MM. dim(in, cm, mode): mode 'first' | 'paren' | 'both'.
     len(in, cm): one length, "47 in (120 cm)" or "120 cm (47 in)". */
  Pdp.prototype.dim = function (inT, cmT, mode) {
    var m = this.data.metric && cmT;
    var f = (m ? cmT : inT) || '', s2 = m ? inT : (cmT || '');
    if (mode === 'first') return f;
    if (mode === 'paren') return f + (s2 ? ' (' + s2 + ')' : '');
    return f + (s2 ? ' · ' + s2 : '');
  };
  Pdp.prototype.len = function (i, c) {
    var n = function (v) { return String(Math.round(v * 100) / 100); };
    return this.dim(n(i) + ' in', c > 0 ? n(c) + ' cm' : '', 'paren');
  };

  Pdp.prototype.findById = function (id) {
    for (var i = 0; i < this.variants.length; i++) if (this.variants[i].id === id) return this.variants[i];
    return null;
  };

  /* ---------- Options ---------- */
  Pdp.prototype.initOptions = function () {
    var self = this;
    this.optionInputs = $$(this.root, '[data-upp-opt-input]');
    this.optionInputs.forEach(function (input) {
      input.addEventListener('change', function () { self.onOptionChange(Number(input.getAttribute('data-upp-opt-input'))); });
    });
  };

  Pdp.prototype.selected = function () {
    var sel = this.variant ? this.variant.options.slice() : [];
    this.optionInputs.forEach(function (input) {
      if (input.checked) sel[Number(input.getAttribute('data-upp-opt-input'))] = input.value;
    });
    return sel;
  };

  Pdp.prototype.onOptionChange = function (changed) {
    var sel = this.selected();
    var exact = null, best = null, bestScore = -1;
    this.variants.forEach(function (v) {
      if (v.options[changed] !== sel[changed]) return;
      var score = 0;
      for (var i = 0; i < v.options.length; i++) if (v.options[i] === sel[i]) score++;
      if (score === v.options.length) exact = v;
      if (score > bestScore || (score === bestScore && v.available && best && !best.available)) { best = v; bestScore = score; }
    });
    var v = exact || best;
    if (!v) return;
    this.setVariant(v, true);
  };

  Pdp.prototype.sizeInfo = function (value) {
    var sizes = this.data.sizes || [];
    for (var i = 0; i < sizes.length; i++) if (sizes[i].value === value) return sizes[i];
    return null;
  };

  Pdp.prototype.setVariant = function (v, fromUser) {
    var self = this, root = this.root;
    this.variant = v;

    // radios follow the variant (a missing combination may have moved another option)
    this.optionInputs.forEach(function (input) {
      var oi = Number(input.getAttribute('data-upp-opt-input'));
      input.checked = v.options[oi] === input.value;
    });

    // ids in every product form of the section (main form + pay-later form)
    $$(root, 'form input[name="id"]').forEach(function (input) {
      input.value = v.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    if (fromUser && window.history && window.history.replaceState) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({ path: url.toString() }, '', url.toString());
      } catch (e) { /* ignore */ }
    }

    // price
    var from = $(root, '[data-upp-from]');
    if (from && fromUser) from.hidden = true;
    var price = $(root, '[data-upp-price]');
    if (price) price.textContent = this.money(v.price);
    /* real compare-at only (snippets/upp-pdp-price): struck price + "Save $X", no badge */
    var disc = v.compare > v.price;   /* a compare-at at or below the price shows nothing, and no amount stays in the DOM */
    var cmp = $(root, '[data-upp-compare]');
    if (cmp) {
      cmp.hidden = !disc;
      $(cmp, '[data-upp-compare-amount]').textContent = disc ? this.money(v.compare) : '';
    }
    var save = $(root, '[data-upp-save]');
    if (save) {
      save.hidden = !disc;
      $(save, '[data-upp-save-amount]').textContent = disc ? this.money(Math.max(0, v.compare - v.price)) : '';
    }
    var saleLabel = $(root, '[data-upp-sale-label]');
    if (saleLabel) saleLabel.hidden = !disc;

    // option labels + availability / per-value prices
    $$(root, '[data-upp-option]').forEach(function (fs) {
      var oi = Number(fs.getAttribute('data-upp-option'));
      var label = $(fs, '[data-upp-opt-label="' + oi + '"]');
      if (label) {
        var info = oi === self.data.sizeIdx ? self.sizeInfo(v.options[oi]) : null;
        label.textContent = info && info.in ? (info.name ? info.name + ' · ' : '') + self.dim(info.in, info.cm, 'first') : v.options[oi];
      }
      $$(fs, '[data-upp-opt-input]').forEach(function (input) {
        var match = self.variants.filter(function (c) {
          if (c.options[oi] !== input.value) return false;
          for (var i = 0; i < c.options.length; i++) if (i !== oi && c.options[i] !== v.options[i]) return false;
          return true;
        })[0];
        var btn = input.closest('label');
        btn.classList.toggle('is-unavailable', !match || !match.available);
        var p = $(btn, '[data-upp-opt-price]');
        if (p) p.textContent = match ? self.money(match.price) : '';
        var st = $(btn, '[data-upp-opt-stock]');
        if (st) st.setAttribute('data-upp-opt-stock', match && match.lt && match.lt.m === 'stock' ? '1' : '');
      });
    });

    this.updateLead(v);
    this.updateSize(v);
    this.updateButtons();
    if (fromUser) this.showMedia(v.media);
    this.updateSet();

    // spec rows for the other options
    $$(root, '[data-upp-spec-opt]').forEach(function (td) {
      td.textContent = v.options[Number(td.getAttribute('data-upp-spec-opt'))] || '';
    });

    root.dispatchEvent(new CustomEvent('upp:variant-change', { bubbles: true, detail: { variant: v } }));
  };

  /* lead time of the chosen variant (snippets/upp-lead-time): in stock / made to order text,
     tag, spec row and the delivery dates (assets/upp-eta.js). */
  Pdp.prototype.updateLead = function (v) {
    var lt = v.lt, root = this.root;
    if (!lt || !lt.o) return;
    // Option rows: only the options this variant has; a hidden choice falls back to Standard.
    $$(root, '[data-upp-opt-row]').forEach(function (row) {
      var k = row.getAttribute('data-upp-opt-row');
      var on = k === 'std' || !!lt.o[k];
      row.hidden = !on || lt.m === 'sold';
      var input = $(row, 'input');
      if (!on && input && input.checked) {
        input.checked = false;
        var std = $(root, '[data-upp-delivery][value="std"]');
        if (std) std.checked = true;
      }
    });
    $$(root, '[data-upp-std-name]').forEach(function (el) { el.textContent = lt.o.std.name; });
    $$(root, '[data-upp-lt-text]').forEach(function (el) { el.textContent = lt.text; });
    $$(root, '[data-upp-lt-short]').forEach(function (el) { el.textContent = lt.short; });
    $$(root, '[data-upp-lt-label]').forEach(function (el) { el.textContent = lt.label; });
    $$(root, '[data-upp-lt-tag]').forEach(function (el) { el.textContent = lt.tag; });
    $$(root, '[data-upp-lt-tagwrap]').forEach(function (el) { el.hidden = !lt.tag; });
    $$(root, '[data-upp-lt-bar]').forEach(function (el) { el.hidden = lt.m === 'sold'; });
    this.updateEta();
  };

  /* Selected delivery option: std | exp | wg (only options the variant has). */
  Pdp.prototype.deliveryOption = function () {
    var r = $(this.root, '[data-upp-delivery]:checked');
    var k = r ? r.value : 'std';
    return this.variant && this.variant.lt && this.variant.lt.o && this.variant.lt.o[k] ? k : 'std';
  };

  /* Date spans: data-upp-eta-opt std | exp | wg | sel (= the selected option), from variants[].lt.o. */
  Pdp.prototype.updateEta = function () {
    var v = this.variant, root = this.root;
    if (!v || !v.lt || !v.lt.o) return;
    var sel = this.deliveryOption();
    /* the box's sentence follows the chosen option too (owner 2026-10-17): "ships in X, then about Y in transit" */
    var so = v.lt.o[sel] || v.lt.o.std;
    $$(root, '[data-upp-lt-text]').forEach(function (el) { el.textContent = (so && so.x) || v.lt.text; });
    $$(root, '[data-upp-eta-variant]').forEach(function (el) {
      var k = el.getAttribute('data-upp-eta-opt') || 'std';
      if (k === 'sel') k = sel;
      var o = v.lt.o[k] || v.lt.o.std;
      el.setAttribute('data-upp-eta-variant', v.id);
      el.setAttribute('data-prep-min', o.p[0]);
      el.setAttribute('data-prep-max', o.p[1]);
      el.setAttribute('data-prep-unit', o.p[2]);
      el.setAttribute('data-tr-min', o.t[0]);
      el.setAttribute('data-tr-max', o.t[1]);
      el.setAttribute('data-tr-unit', o.t[2]);
    });
    if (window.uppEta) window.uppEta(root);
  };

  Pdp.prototype.updateSize = function (v) {
    var root = this.root, idx = this.data.sizeIdx;
    if (idx == null || idx < 0) {
      /* a ready-to-ship piece draws its own one size (data.rtsSize); other products without a Size option, the reference view */
      if (this.data.rtsSize) this.drawSize(this.data.rtsSize);
      else if (this.data.elev) this.drawSize({});
      return;
    }
    var info = this.sizeInfo(v.options[idx]) || { value: v.options[idx] };
    var sizeText = info.in ? this.dim(info.in, info.cm, 'paren') : info.value;
    var cell = $(root, '[data-upp-spec-size]');
    if (cell) cell.textContent = sizeText;
    var seatsRow = $(root, '[data-upp-spec-seats-row]');
    if (seatsRow) {
      seatsRow.hidden = !info.seats;
      $(seatsRow, '[data-upp-spec-seats]').textContent = info.seats || '';
    }
    var barSize = info.in ? this.dim(info.in, info.cm, 'first') : info.value;
    $$(root, '[data-upp-bar-size]').forEach(function (el) { el.textContent = barSize; });   /* name line + phone price line */
    this.drawSize(info);
  };

  /* Top-view drawing, to scale: tabletop plus chairs around it, 2 in from the edge. Chairs use
     the set chair's real footprint (data.chair, from its custom.size_entries, e.g. 18 x 18 in)
     with a "Chair 18 in (46 cm) wide" label; without it a generic 18 x 16 in seat and no label.
     Chair count = the top of the seat range ("seats 6–8" draws 8), placed by chairLayout (one at
     each end from 4 chairs when the end is wide enough), evenly spaced along the long sides (if a side ever holds more chair widths
     than the table is long, they sit 1 in apart, centred). No seat count, no chairs.
     Every [data-upp-dw] in the section is drawn: the gallery tile and the size guide dialog's copy. */
  Pdp.prototype.drawSize = function (info) {
    var self = this;
    this.sizeNow = info;
    $$(this.root, '[data-upp-dw]').forEach(function (dw) { self.drawSizeIn(dw, info); });
  };

  /* Chairs around a rectangular table (owner 2026-10-16), shared with the Size Guide page:
     from 4 chairs one goes at each end, the rest split along the two long sides, the odd one on the
     top side: 2 -> 1+1, 4 -> 1+1 +1+1 ends, 6 -> 2+2 +1+1, 8 -> 3+3 +1+1, 10 -> 4+4 +1+1, 5 -> 2+1 +1+1.
     An end narrower than the chair + 4 in (depth < chairW + 4) takes no chair: all on the long sides.
     Long-side chairs are spaced evenly along the side. Round tables: evenly around the circle. */
  Pdp.prototype.chairLayout = function (n, depth, chairW) {
    var ends = n >= 4 && depth >= (chairW || 18) + 4 ? 1 : 0;
    var sides = Math.max(0, n - 2 * ends);
    return { ends: ends, top: Math.ceil(sides / 2), bottom: Math.floor(sides / 2) };
  };

  Pdp.prototype.chairText = function () {
    var ch = this.data.chair;
    return ch ? 'Chair ' + this.len(ch.w, ch.wcm) + ' wide' : '';
  };

  /* A size the drawing can't read (no W x D, or no stored dims): clear the figure instead of leaving the previous
     size's drawing, info line and caption on screen next to the new size (review 2026-10-18). The size chips stay. */
  Pdp.prototype.noDrawing = function (dw, svg) {
    dw.classList.remove('is-room', 'is-room-wait', 'is-photo', 'is-roomphoto', 'is-sofa');
    dw.classList.add('is-none');
    if (svg) { svg.innerHTML = ''; svg.removeAttribute('preserveAspectRatio'); }
    var th = $(dw, '[data-upp-th]'); if (th) th.remove();
    var inf = $(dw, '[data-upp-dw-info]');
    if (inf) { inf.hidden = false; inf.textContent = 'No drawing for this size'; }
    var cap = $(dw, '[data-upp-dw-cap]');
    if (cap) cap.textContent = 'No drawing for this size.';
  };

  Pdp.prototype.drawSizeIn = function (dw, info) {
    if (dw.getAttribute('data-mode') === 'elev') { this.drawElev(dw, info); return; }
    var svg = $(dw, 'svg');
    var count = info.count || 0, a = info.a || 0, b = info.b || 0, ca = info.ca || 0, cb = info.cb || 0;
    var kind = '';
    if (count === 2 && a > 0 && b > 0) kind = 'rect';
    else if (count === 1 && this.data.round && a > 0) kind = 'circle';
    if (!svg) { dw.classList.remove('is-room-wait'); return; }
    if (!kind) { this.noDrawing(dw, svg); return; }
    dw.classList.remove('is-none');
    if (b > a) { var t = a; a = b; b = t; t = ca; ca = cb; cb = t; }
    var h = this.data.height;
    var meta = [];
    if (h && h.in) meta.push('Height ' + this.dim(h.in + ' in', h.cm ? h.cm + ' cm' : '', 'paren'));
    if (info.seats) meta.push('seats ' + info.seats);
    var self = this, label = function (n, c) { return self.len(n, c); };
    var nums = String(info.seats || '').match(/\d+/g);
    var n = nums ? parseInt(nums[nums.length - 1], 10) : 0;
    if (n > 16) n = 16;

    var ch = this.data.chair, CW = ch ? ch.w : 18, CD = ch ? ch.d : 16, GAP = 2, OUT = GAP + CD;
    var info2 = $(dw, '[data-upp-dw-info]');
    var roomSrc = dw.getAttribute('data-room-src');
    if (n > 0 && roomSrc) {
      this.drawRoom(dw, svg, kind, a, b, ca, cb, n, label);
      if (info2) { info2.hidden = false; info2.textContent = (info.seats ? 'Seats ' + info.seats + ' · ' : '') + (this.data.metric ? 'Room about 4.3 × 4.3 m' : 'Room about 14 × 14 ft'); }
      var capR = $(dw, '[data-upp-dw-cap]');
      if (capR) capR.textContent = 'Top view: ' + this.dim(info.in || '', info.cm, 'paren') + ' table with ' + n + ' chairs in a room of about ' + (this.data.metric ? '4.3 by 4.3 metres' : '14 by 14 feet') + (info.seats ? ', seats ' + info.seats : '');
      return;
    }
    dw.classList.remove('is-room-wait');
    dw.classList.remove('is-room');
    svg.removeAttribute('preserveAspectRatio');
    if (info2) info2.hidden = true;
    var INK = '#442E13', BARK = '#72624D', EDGE = '#867762', FILL = '#EDE4D6', TOP = '#FCFAF6';
    var r = function (v) { return Math.round(v * 10) / 10; };
    var out = [];
    var chair = function (cx, cy, w, d, angle) {
      /* seat centred on (cx, cy); the back sits on the side away from the table */
      var g = '<g transform="translate(' + r(cx) + ' ' + r(cy) + ') rotate(' + angle + ')">' +
        '<rect x="' + r(-w / 2) + '" y="' + r(-d / 2) + '" width="' + r(w) + '" height="' + r(d) + '" rx="' + r(d * 0.18) + '" fill="' + FILL + '" stroke="' + EDGE + '" stroke-width="1.2"/>' +
        '<line x1="' + r(-w / 2 + 1) + '" y1="' + r(-d / 2) + '" x2="' + r(w / 2 - 1) + '" y2="' + r(-d / 2) + '" stroke="' + EDGE + '" stroke-width="3" stroke-linecap="round"/></g>';
      out.push(g);
    };
    var W = 300, metaY;

    if (kind === 'rect') {
      var lay = this.chairLayout(n, b, CW), ends = lay.ends, topN = lay.top, botN = lay.bottom;
      var ex = ends ? OUT : 0, eyT = topN ? OUT : 0, eyB = botN ? OUT : 0;
      var s = Math.min(220 / (a + 2 * ex), 160 / (b + eyT + eyB));
      var tw = a * s, th = b * s;
      var tx = 135 - tw / 2;
      var ty = 40 + eyT * s;
      /* width dimension above everything */
      out.push('<line x1="' + r(tx) + '" y1="28" x2="' + r(tx + tw) + '" y2="28" stroke="' + BARK + '"/>');
      out.push('<line x1="' + r(tx) + '" y1="24" x2="' + r(tx) + '" y2="32" stroke="' + BARK + '"/><line x1="' + r(tx + tw) + '" y1="24" x2="' + r(tx + tw) + '" y2="32" stroke="' + BARK + '"/>');
      out.push('<text x="' + r(tx + tw / 2) + '" y="18" text-anchor="middle">' + label(a, ca) + '</text>');
      /* chairs */
      var k;
      var along = function (k, N) { var span = N * CW <= a ? tw : N * (CW + 1) * s; return tx + tw / 2 - span / 2 + span * (k + 0.5) / N; };
      for (k = 0; k < topN; k++) chair(along(k, topN), ty - (GAP + CD / 2) * s, CW * s, CD * s, 0);
      for (k = 0; k < botN; k++) chair(along(k, botN), ty + th + (GAP + CD / 2) * s, CW * s, CD * s, 180);
      if (ends) {
        chair(tx - (GAP + CD / 2) * s, ty + th / 2, CW * s, CD * s, -90);
        chair(tx + tw + (GAP + CD / 2) * s, ty + th / 2, CW * s, CD * s, 90);
      }
      /* tabletop */
      out.push('<rect x="' + r(tx) + '" y="' + r(ty) + '" width="' + r(tw) + '" height="' + r(th) + '" fill="' + TOP + '" stroke="' + INK + '" stroke-width="2"/>');
      /* depth dimension to the right */
      var dx = tx + tw + ex * s + 12;
      out.push('<line x1="' + r(dx) + '" y1="' + r(ty) + '" x2="' + r(dx) + '" y2="' + r(ty + th) + '" stroke="' + BARK + '"/>');
      out.push('<line x1="' + r(dx - 4) + '" y1="' + r(ty) + '" x2="' + r(dx + 4) + '" y2="' + r(ty) + '" stroke="' + BARK + '"/><line x1="' + r(dx - 4) + '" y1="' + r(ty + th) + '" x2="' + r(dx + 4) + '" y2="' + r(ty + th) + '" stroke="' + BARK + '"/>');
      var my = ty + th / 2, mx = dx + 10;
      out.push('<text x="' + r(mx) + '" y="' + r(my) + '" text-anchor="middle" transform="rotate(90 ' + r(mx) + ' ' + r(my) + ')">' + label(b, cb) + '</text>');
      metaY = ty + th + eyB * s + 26;
      W = Math.max(300, Math.ceil(mx + 14));
    } else {
      var R = a / 2, ring = n ? OUT : 0;
      var sc = Math.min(200 / (a + 2 * ring), 170 / (a + 2 * ring));
      var cx = 150, cy = 40 + (ring + R) * sc;
      for (var i = 0; i < n; i++) {
        var ang = -90 + 360 * i / n, rad = ang * Math.PI / 180, dist = (R + GAP + CD / 2) * sc;
        chair(cx + Math.cos(rad) * dist, cy + Math.sin(rad) * dist, CW * sc, CD * sc, ang + 90);
      }
      out.push('<circle cx="' + cx + '" cy="' + r(cy) + '" r="' + r(R * sc) + '" fill="' + TOP + '" stroke="' + INK + '" stroke-width="2"/>');
      out.push('<line x1="' + r(cx - R * sc) + '" y1="' + r(cy) + '" x2="' + r(cx + R * sc) + '" y2="' + r(cy) + '" stroke="' + BARK + '" stroke-dasharray="4 4"/>');
      out.push('<text x="' + cx + '" y="' + r(cy - 8) + '" text-anchor="middle">' + label(a, ca) + '</text>');
      metaY = cy + (R + ring) * sc + 26;
    }
    if (meta.length) out.push('<text class="upp-pdp-dw__meta" x="' + r(W / 2) + '" y="' + r(metaY) + '" text-anchor="middle">' + meta.join(' · ') + '</text>');
    if (n > 0 && this.chairText()) {
      if (meta.length) metaY += 18;
      out.push('<text class="upp-pdp-dw__meta" x="' + r(W / 2) + '" y="' + r(metaY) + '" text-anchor="middle">' + this.chairText() + '</text>');
    }
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + Math.ceil(metaY + 10));
    svg.innerHTML = out.join('');
    var cap = $(dw, '[data-upp-dw-cap]');
    if (cap) cap.textContent = 'Dimensions drawing: ' + this.dim(info.in || '', info.cm, 'paren') +
      (h && h.in ? ', ' + h.in + ' in high' : '') + (info.seats ? ', seats ' + info.seats : '') +
      (n ? ', shown with ' + n + ' chairs' : '');
  };

  /* Room view: the Higgsfield top-down room (floor = x 77–956, y 85–944 of 1024 px, declared
     168 in / 14 ft wide) with the table and chairs drawn over it at the same scale. */
  Pdp.prototype.drawRoom = function (dw, svg, kind, a, b, ca, cb, n, label) {
    var F = { x: 77, y: 85, w: 879, h: 859 }, s = F.w / 168;
    var ch = this.data.chair, CW = ch ? ch.w : 18, CD = ch ? ch.d : 16, GAP = 2, OUT = GAP + CD;
    var chairTxt = this.chairText();
    var r = function (v) { return Math.round(v * 10) / 10; };
    var WOOD = '#6B4A2E', WOOD_D = '#3B2716', SEAT = '#2A2420', INK = '#1A1512', PAPER = '#FCFAF6';
    var out = [];
    /* the room photo is the figure's <img class="upp-pdp-dw__room"> under the svg (snippets/upp-pdp-drawing).
       Chairs and tabletop are Higgsfield top views (2026-10-17): the chair image fills the chair's real
       footprint (backrest away from the table), the walnut texture is cropped (not stretched) to the top. */
    var chairSrc = dw.getAttribute('data-chair-src'), topSrc = dw.getAttribute('data-top-src');
    var clipId = 'uppTop' + Math.random().toString(36).slice(2, 8);
    var chair = function (cx, cy, angle) {
      var w = CW * s, d = CD * s;
      out.push('<g transform="translate(' + r(cx) + ' ' + r(cy) + ') rotate(' + angle + ')">' + (chairSrc
        ? '<image href="' + chairSrc + '" x="' + r(-w / 2) + '" y="' + r(-d / 2) + '" width="' + r(w) + '" height="' + r(d) + '" preserveAspectRatio="none"/>'
        : '<rect x="' + r(-w / 2) + '" y="' + r(-d / 2) + '" width="' + r(w) + '" height="' + r(d) + '" rx="' + r(d * 0.2) + '" fill="' + SEAT + '" stroke="' + WOOD + '" stroke-width="5"/>' +
          '<line x1="' + r(-w / 2 + 4) + '" y1="' + r(-d / 2) + '" x2="' + r(w / 2 - 4) + '" y2="' + r(-d / 2) + '" stroke="' + WOOD + '" stroke-width="11" stroke-linecap="round"/>') + '</g>');
    };
    /* tabletop: walnut colour first (shows while the texture loads), texture clipped to the shape, outline on top */
    var top = function (shape, bx, by, bw, bh) {
      out.push(shape.replace('/>', ' fill="' + WOOD + '"/>'));
      if (topSrc) {
        out.push('<clipPath id="' + clipId + '">' + shape + '</clipPath>');
        var rot = bh > bw * 1.2;   /* texture grain runs along the long side */
        out.push(rot
          ? '<image href="' + topSrc + '" x="' + r(bx + bw / 2 - bh / 2) + '" y="' + r(by + bh / 2 - bw / 2) + '" width="' + r(bh) + '" height="' + r(bw) + '" preserveAspectRatio="xMidYMid slice" transform="rotate(90 ' + r(bx + bw / 2) + ' ' + r(by + bh / 2) + ')" clip-path="url(#' + clipId + ')"/>'
          : '<image href="' + topSrc + '" x="' + r(bx) + '" y="' + r(by) + '" width="' + r(bw) + '" height="' + r(bh) + '" preserveAspectRatio="xMidYMid slice" clip-path="url(#' + clipId + ')"/>');
      }
      out.push(shape.replace('/>', ' fill="none" stroke="' + WOOD_D + '" stroke-width="4"/>'));
    };
    var lbl = function (x, y, text, rot, cls) {
      out.push('<text class="upp-pdp-dw__lbl' + (cls ? ' ' + cls : '') + '" x="' + r(x) + '" y="' + r(y) + '" text-anchor="middle"' + (rot ? ' transform="rotate(' + rot + ' ' + r(x) + ' ' + r(y) + ')"' : '') + '>' + text + '</text>');
    };
    var cx = F.x + F.w / 2, cy = F.y + F.h * 0.46;
    if (kind === 'rect') {
      var lay = this.chairLayout(n, b, CW), ends = lay.ends, topN = lay.top, botN = lay.bottom;
      var tw = a * s, th = b * s, tx = cx - tw / 2, ty = cy - th / 2, k;
      var along = function (k, N) { var span = N * CW <= a ? tw : N * (CW + 1) * s; return cx - span / 2 + span * (k + 0.5) / N; };
      for (k = 0; k < topN; k++) chair(along(k, topN), ty - (GAP + CD / 2) * s, 0);
      for (k = 0; k < botN; k++) chair(along(k, botN), ty + th + (GAP + CD / 2) * s, 180);
      if (ends) { chair(tx - (GAP + CD / 2) * s, cy, -90); chair(tx + tw + (GAP + CD / 2) * s, cy, 90); }
      /* oval tables (title says oval, owner 2026-10-19): the top is an ellipse, so their own top view's oval edge fits */
      top(dw.hasAttribute('data-oval')
        ? '<ellipse cx="' + r(cx) + '" cy="' + r(cy) + '" rx="' + r(tw / 2) + '" ry="' + r(th / 2) + '"/>'
        : '<rect x="' + r(tx) + '" y="' + r(ty) + '" width="' + r(tw) + '" height="' + r(th) + '" rx="3"/>', tx, ty, tw, th);
      var ly = ty - (topN ? OUT : 0) * s - 22;
      out.push('<path d="M' + r(tx) + ' ' + r(ly - 10) + 'v20M' + r(tx) + ' ' + r(ly) + 'H' + r(tx + tw) + 'M' + r(tx + tw) + ' ' + r(ly - 10) + 'v20" stroke="' + INK + '" stroke-width="3" fill="none"/>');
      lbl(cx, ly - 18, label(a, ca));
      var lx = tx + tw + (ends ? OUT : 0) * s + 24;
      out.push('<path d="M' + r(lx - 10) + ' ' + r(ty) + 'h20M' + r(lx) + ' ' + r(ty) + 'V' + r(ty + th) + 'M' + r(lx - 10) + ' ' + r(ty + th) + 'h20" stroke="' + INK + '" stroke-width="3" fill="none"/>');
      lbl(lx + 30, cy, label(b, cb), 90);
      /* chair width under the bottom row; above the width label if that would reach the text band */
      if (chairTxt) {
        var cyB = ty + th + (botN ? OUT : 0) * s + 46;
        lbl(cx, cyB <= 780 ? cyB : ly - 64, chairTxt, 0, 'upp-pdp-dw__lbl--sm');
      }
    } else {
      var R = a / 2 * s;
      for (var i = 0; i < n; i++) {
        var ang = -90 + 360 * i / n, rad = ang * Math.PI / 180, dist = R + (GAP + CD / 2) * s;
        chair(cx + Math.cos(rad) * dist, cy + Math.sin(rad) * dist, ang + 90);
      }
      top('<circle cx="' + r(cx) + '" cy="' + r(cy) + '" r="' + r(R) + '"/>', cx - R, cy - R, 2 * R, 2 * R);
      out.push('<line x1="' + r(cx - R) + '" y1="' + r(cy) + '" x2="' + r(cx + R) + '" y2="' + r(cy) + '" stroke="' + PAPER + '" stroke-width="3" stroke-dasharray="10 8"/>');
      lbl(cx, cy - 16, label(a, ca));
      if (chairTxt) lbl(cx, cy - R - OUT * s - 22, chairTxt, 0, 'upp-pdp-dw__lbl--sm');
    }
    dw.classList.add('is-room');
    dw.classList.remove('is-room-wait');
    svg.setAttribute('viewBox', '0 0 1024 1024');
    svg.setAttribute('preserveAspectRatio', 'xMidYMid slice');
    svg.innerHTML = out.join('');
  };

  /* Front view for everything that doesn't get the dining room view (data.elev from
     snippets/upp-pdp-ref-data): the piece as a flat walnut shape (tables / consoles / desks /
     benches with a top and two legs, others a block), W x H to scale, standing on one floor line
     beside a reference at the same scale: a 5 ft 7 in person, a standard 84 in sofa (seat 18,
     back 34 in) or a bed edge with a 25 in top. References are common sizes, not UPP products.
     No height: a top view, the footprint beside the sofa's 84 x 36 in footprint, a person's
     shoulders (18 in) or, for beds, a person lying down. */
  Pdp.prototype.drawElev = function (dw, info) {
    var E = this.data.elev, svg = $(dw, 'svg');
    if (!E || !svg) return;
    var sizes = this.data.sizes || [];
    var dm = E.dims[Math.max(0, sizes.indexOf(info))] || E.dims[0];
    /* "Set of 2" (nesting sets sold one by one or together, owner 2026-10-18): no size of its own; the photos show the
       set nested, so it is drawn at the largest piece's size (the smaller one slides under it) */
    if (dm && !dm.w && info && /set of|both/i.test(String(info.value || info.name || ''))) {
      var parts = E.dims.filter(function (x) { return x && x.w > 0 && x.h > 0; });
      if (parts.length > 1) {
        var big = parts.slice().sort(function (a, b) { return b.w * b.h - a.w * a.h; })[0];
        dm = { w: big.w, wc: big.wc, h: big.h, hc: big.hc, d: big.d, dc: big.dc, nested: parts.length };
      }
    }
    if (!dm || !dm.w) { this.noDrawing(dw, svg); return; }
    dw.classList.remove('is-none');
    var r = function (v) { return Math.round(v * 10) / 10; };
    var num = function (v) { return String(Math.round(v * 100) / 100); };
    var self = this, len = function (i, c) { return self.len(i, c); };
    var mt = this.data.metric, two = function (i, c) { return mt ? c + ' (' + i + ')' : i + ' (' + c + ')'; };
    var WAL = '#6B4A2E', WAL_D = '#442E13', REF = '#EDE4D6', REF_E = '#867762', BARK = '#72624D';
    var VW = 600, VH = 480, out = [];
    var front = dm.h > 0;
    /* a front-view photo of the piece (chairs): drawn in a room beside the person and a table, when its
       shape matches the stored size (within 15%), so a wrong size entry never stretches the photo */
    /* Higgsfield photos of the piece (custom.front_view / top_view, owner 2026-10-17), by kind (snippets/upp-pdp-ref-data):
       chair: room + person + table heights (only when the photo matches the stored size, within 15%); console: room +
       person; coffee / side: with a standard sofa, front view and plan; everything else: person, front and top on white */
    var K = E.kind;
    dw._uppKind = K;
    if (front && E.fr) {
      /* chairs and consoles: the piece alone in the room, no person or table (owner 2026-10-18; chairs to be revisited) */
      if (K === 'chair') { this.drawChairRoom(dw, svg, dm, E.fr, 'alone'); return; }
      else if (K === 'console') { this.drawChairRoom(dw, svg, dm, E.fr, 'alone'); return; }   /* no person (owner 2026-10-18) */
      else if (K === 'coffee' || K === 'side') { this.drawSofaScene(dw, svg, dm, E, K); return; }
      else { this.drawTwoViews(dw, svg, dm, E); return; }
    }
    /* a size without a height after a photo view: drop the room photo's slice crop and 600:450 box too (review 2026-10-18) */
    dw.classList.remove('is-photo', 'is-roomphoto', 'is-sofa');
    svg.removeAttribute('preserveAspectRatio');
    var oldTh = $(dw, '[data-upp-th]'); if (oldTh) oldTh.remove();
    var refKind = E.ref, lie = !front && E.lie;
    var personSrc = dw.getAttribute('data-person-src');
    var R;   /* reference: w, h (front) or w, d (top), label, info line */
    /* no person anywhere (owner 2026-10-18): without a sofa or bed reference the piece is drawn alone, filling the frame */
    var noRef = refKind !== 'sofa' && !(front && refKind === 'bed');
    if (front) {
      if (refKind === 'sofa') R = { w: 84, h: 34, label: 'Sofa ' + two('84 in', '213 cm') + ' · seat ' + two('18 in', '46 cm'), info: 'Shown next to a standard ' + two('84 in', '213 cm') + ' sofa' };
      else if (refKind === 'bed') R = { w: 40, h: 25, label: 'Bed top ' + two('25 in', '64 cm'), info: 'Shown next to a standard bed, ' + two('25 in', '64 cm') + ' high' };
      else R = { w: 18, h: 67, label: 'Person ' + two('5 ft 7 in', '170 cm'), info: 'Shown next to a ' + two('5 ft 7 in', '170 cm') + ' person' };
    } else {
      if (refKind === 'sofa') R = { w: 84, h: 36, label: 'Sofa ' + two('84 × 36 in', '213 × 91 cm'), info: 'Seen from above, next to a standard ' + two('84 in', '213 cm') + ' sofa' };
      else if (lie) R = { w: 67, h: 18, label: 'Person ' + two('5 ft 7 in', '170 cm'), info: 'Seen from above, next to a ' + two('5 ft 7 in', '170 cm') + ' person' };
      else R = { w: 18, h: 10, label: 'Person, shoulders ' + two('18 in', '46 cm'), info: 'Seen from above, next to a person\u2019s ' + two('18 in', '46 cm') + ' shoulders' };
    }
    if (noRef) R = { w: 0, h: 0, label: '', info: front ? 'Front view, drawn to scale' : 'Seen from above, drawn to scale' };
    var PW = dm.w, PH = front ? dm.h : dm.d;
    var GAP = noRef ? 0 : front ? (refKind === 'bed' ? 3 : 12) : 12;
    var top = 64, floorY = front ? 392 : 0, availH = front ? floorY - top : 300;
    var s = Math.min((VW - 120) / (R.w + GAP + PW), availH / Math.max(PH, R.h));
    if (noRef) s = Math.min((VW - 160) / PW, availH * 0.82 / PH);
    var groupW = (R.w + GAP + PW) * s;
    var x0 = (VW - 40 - groupW) / 2;            /* room on the right for the height label */
    var rx = x0, px = x0 + (R.w + GAP) * s;
    var txt = function (x, y, t, cls, rot) {
      if (cls === 'ref') x = Math.min(Math.max(x, 150), VW - 150);   /* keep long labels inside the frame */
      out.push('<text class="upp-pdp-dw__e' + cls + '" x="' + r(x) + '" y="' + r(y) + '" text-anchor="middle"' + (rot ? ' transform="rotate(' + rot + ' ' + r(x) + ' ' + r(y) + ')"' : '') + '>' + t + '</text>');
    };
    var rect = function (x, y, w, h, fill, edge, rad) {
      out.push('<rect x="' + r(x) + '" y="' + r(y) + '" width="' + r(w) + '" height="' + r(h) + '"' + (rad ? ' rx="' + r(rad) + '"' : '') + ' fill="' + fill + '" stroke="' + edge + '" stroke-width="1.5"/>');
    };
    var dimH = function (x1, x2, y, t) {
      out.push('<path d="M' + r(x1) + ' ' + r(y - 7) + 'v14M' + r(x1) + ' ' + r(y) + 'H' + r(x2) + 'M' + r(x2) + ' ' + r(y - 7) + 'v14" stroke="' + BARK + '" stroke-width="1.5" fill="none"/>');
      txt((x1 + x2) / 2, y - 10, t, 'dim');
    };
    var dimV = function (x, y1, y2, t) {
      out.push('<path d="M' + r(x - 7) + ' ' + r(y1) + 'h14M' + r(x) + ' ' + r(y1) + 'V' + r(y2) + 'M' + r(x - 7) + ' ' + r(y2) + 'h14" stroke="' + BARK + '" stroke-width="1.5" fill="none"/>');
      txt(x + 22, (y1 + y2) / 2, t, 'dim', 90);
    };

    if (front) {
      var u = function (v) { return v * s; };   /* inches -> px */
      var fy = function (hIn) { return floorY - hIn * s; };
      out.push('<line x1="12" y1="' + floorY + '" x2="' + (VW - 12) + '" y2="' + floorY + '" stroke="' + BARK + '" stroke-width="1.5"/>');
      /* reference */
      if (noRef) {
        /* none */
      } else if (refKind === 'sofa') {
        rect(rx + u(2), fy(4), u(2.5), u(4), REF_E, REF_E); rect(rx + u(79.5), fy(4), u(2.5), u(4), REF_E, REF_E);
        rect(rx + u(7), fy(34), u(70), u(16), REF, REF_E, u(3));
        rect(rx + u(7), fy(18), u(70), u(14), REF, REF_E, u(1.5));
        rect(rx, fy(25), u(7), u(21), REF, REF_E, u(2.5)); rect(rx + u(77), fy(25), u(7), u(21), REF, REF_E, u(2.5));
        out.push('<line x1="' + r(rx + u(42)) + '" y1="' + r(fy(18)) + '" x2="' + r(rx + u(42)) + '" y2="' + r(fy(10)) + '" stroke="' + REF_E + '" stroke-width="1"/>');
      } else if (refKind === 'bed') {
        rect(rx, fy(10), u(40), u(6), REF, REF_E, 0);
        rect(rx + u(37), fy(4), u(2.5), u(4), REF_E, REF_E);
        rect(rx, fy(25), u(40), u(15), REF, REF_E, u(3));
        out.push('<path d="M' + r(rx) + ' ' + r(fy(26)) + 'v' + r(u(24)) + '" stroke="#FCFAF6" stroke-width="3"/>');
      } else if (personSrc) {
        /* photo figure at true scale: 900 px = 67 in, width 0.2 x height, soles on the floor line */
        var ph = u(67), pw = ph * 0.2;
        out.push('<image data-upp-lazy x="' + r(rx + u(9) - pw / 2) + '" y="' + r(fy(67)) + '" width="' + r(pw) + '" height="' + r(ph) + '" preserveAspectRatio="xMidYMax meet"' +
          (dw._uppNear ? ' href="' + personSrc + '"' : '') + '/>');
      } else {
        var cx = rx + u(9);
        out.push('<g fill="' + REF + '" stroke="' + REF_E + '" stroke-width="1.5">' +
          '<circle cx="' + r(cx) + '" cy="' + r(fy(62.3)) + '" r="' + r(u(4.6)) + '"/>' +
          '<rect x="' + r(cx - u(8)) + '" y="' + r(fy(56.5)) + '" width="' + r(u(16)) + '" height="' + r(u(23.5)) + '" rx="' + r(u(3)) + '"/>' +
          '<rect x="' + r(cx - u(10.5)) + '" y="' + r(fy(55.5)) + '" width="' + r(u(3.4)) + '" height="' + r(u(25)) + '" rx="' + r(u(1.7)) + '"/>' +
          '<rect x="' + r(cx + u(7.1)) + '" y="' + r(fy(55.5)) + '" width="' + r(u(3.4)) + '" height="' + r(u(25)) + '" rx="' + r(u(1.7)) + '"/>' +
          '<rect x="' + r(cx - u(6.6)) + '" y="' + r(fy(34)) + '" width="' + r(u(6)) + '" height="' + r(u(34)) + '" rx="' + r(u(2)) + '"/>' +
          '<rect x="' + r(cx + u(0.6)) + '" y="' + r(fy(34)) + '" width="' + r(u(6)) + '" height="' + r(u(34)) + '" rx="' + r(u(2)) + '"/></g>');
      }
      if (!noRef) txt(rx + u(R.w) / 2, floorY + 30, R.label, 'ref');
      /* the piece */
      if (E.shape === 'table' && PW > 8 && PH > 6) {
        var t = Math.min(2, PH * 0.12), leg = Math.min(2.2, PW * 0.08), ins = Math.min(1.5, PW * 0.05);
        rect(px + u(ins), fy(PH - t), u(leg), u(PH - t), WAL, WAL_D);
        rect(px + u(PW - ins - leg), fy(PH - t), u(leg), u(PH - t), WAL, WAL_D);
        rect(px, fy(PH), u(PW), u(t), WAL, WAL_D, u(0.5));
      } else {
        rect(px, fy(PH), u(PW), u(PH), WAL, WAL_D, u(1));
      }
      dimH(px, px + u(PW), fy(PH) - 16, len(dm.w, dm.wc));
      dimV(px + u(PW) + 14, fy(PH), floorY, len(dm.h, dm.hc));
      if (dm.d > 0) txt(px + u(PW) / 2, floorY + 58, 'Depth ' + len(dm.d, dm.dc), 'ref');
    } else {
      var cy = 64 + availH / 2;
      var u2 = function (v) { return v * s; };
      /* reference footprint, centred on the same line */
      var ry = cy - u2(R.h) / 2;
      if (noRef) {
        /* none */
      } else if (refKind === 'sofa') {
        rect(rx, ry, u2(84), u2(36), REF, REF_E, u2(3));
        rect(rx + u2(7), ry, u2(70), u2(9), REF, REF_E, u2(2));
        rect(rx, ry, u2(7), u2(36), REF, REF_E, u2(2.5)); rect(rx + u2(77), ry, u2(7), u2(36), REF, REF_E, u2(2.5));
      } else if (lie) {
        out.push('<g fill="' + REF + '" stroke="' + REF_E + '" stroke-width="1.5">' +
          '<circle cx="' + r(rx + u2(4.6)) + '" cy="' + r(cy) + '" r="' + r(u2(4.6)) + '"/>' +
          '<rect x="' + r(rx + u2(10)) + '" y="' + r(cy - u2(9)) + '" width="' + r(u2(24)) + '" height="' + r(u2(18)) + '" rx="' + r(u2(4)) + '"/>' +
          '<rect x="' + r(rx + u2(33)) + '" y="' + r(cy - u2(6.5)) + '" width="' + r(u2(34)) + '" height="' + r(u2(5.6)) + '" rx="' + r(u2(2.4)) + '"/>' +
          '<rect x="' + r(rx + u2(33)) + '" y="' + r(cy + u2(0.9)) + '" width="' + r(u2(34)) + '" height="' + r(u2(5.6)) + '" rx="' + r(u2(2.4)) + '"/></g>');
      } else {
        out.push('<g fill="' + REF + '" stroke="' + REF_E + '" stroke-width="1.5">' +
          '<ellipse cx="' + r(rx + u2(9)) + '" cy="' + r(cy) + '" rx="' + r(u2(9)) + '" ry="' + r(u2(5)) + '"/>' +
          '<circle cx="' + r(rx + u2(9)) + '" cy="' + r(cy) + '" r="' + r(u2(3.8)) + '"/></g>');
      }
      if (!noRef) txt(rx + u2(R.w) / 2, cy + Math.max(u2(R.h), u2(PH)) / 2 + 32, R.label, 'ref');
      var py = cy - u2(PH) / 2;
      rect(px, py, u2(PW), u2(PH), WAL, WAL_D, u2(1));
      dimH(px, px + u2(PW), py - 16, len(dm.w, dm.wc));
      dimV(px + u2(PW) + 14, py, py + u2(PH), len(dm.d, dm.dc));
    }

    /* crop to the drawing: from just above the tallest shape to the labels under it */
    var vbTop, vbBot;
    if (front) { vbTop = floorY - Math.max(PH, R.h) * s - 52; vbBot = floorY + (dm.d > 0 ? 66 : 42); }
    else { var half = Math.max(PH, R.h) * s / 2; vbTop = cy - half - 52; vbBot = cy + half + 46; }
    vbTop = Math.max(0, Math.floor(vbTop));
    svg.setAttribute('viewBox', '0 ' + vbTop + ' ' + VW + ' ' + Math.ceil(Math.min(VH, vbBot) - vbTop));
    svg.innerHTML = out.join('');
    var inf = $(dw, '[data-upp-dw-info]');
    if (inf) { inf.hidden = false; inf.textContent = R.info; }
    /* the person photo loads only when the tile is near the viewport (the dialog copy has _uppNear) */
    if (!dw._uppNear && !dw._uppIoP && $(dw, '[data-upp-lazy]')) {
      var fill = function () {
        dw._uppNear = true;
        $$(dw, '[data-upp-lazy]').forEach(function (im) { im.setAttribute('href', im.getAttribute('data-src') || personSrc); });
      };
      if ('IntersectionObserver' in window) {
        dw._uppIoP = new IntersectionObserver(function (entries) {
          if (!entries.some(function (e) { return e.isIntersecting; })) return;
          dw._uppIoP.disconnect();
          fill();
        }, { rootMargin: '400px' });
        dw._uppIoP.observe(dw);
      } else fill();
    }
    var cap = $(dw, '[data-upp-dw-cap]');
    if (cap) cap.textContent = (front ? 'Front view: ' + len(dm.w, dm.wc) + ' wide, ' + len(dm.h, dm.hc) + ' high' + (dm.d > 0 ? ', ' + len(dm.d, dm.dc) + ' deep' : '') :
      'Seen from above: ' + len(dm.w, dm.wc) + ' by ' + len(dm.d, dm.dc)) + '. ' + R.info + '.';
  };

  /* Chair front view in a room (owner 2026-10-17): the empty room photo (assets/upp-room-front.webp, floor
     line at y 432 of 480), a 5 ft 7 in person (cut at the chest for chairs), the chair's front photo at its stored W x H, and the end of a
     table at the picked height, all to one scale; table-height chips under it (28 / 29.5 = UPP tables / 30 /
     36 in counter) redraw it. Photos load when the tile nears the viewport, like the person figure. */
  Pdp.prototype.drawChairRoom = function (dw, svg, dm, fr, withTable) {
    var self = this, r = function (v) { return Math.round(v * 10) / 10; };
    var len = function (i, c) { return self.len(i, c); };
    var mt = this.data.metric, two = function (i, c) { return mt ? c + ' (' + i + ')' : i + ' (' + c + ')'; };
    var INK = '#1A1512', WAL = '#6B4A2E', WAL_D = '#442E13';
    var HEIGHTS = [{ h: 28, c: 71 }, { h: 30, c: 76, ours: true }, { h: 36, c: 91, note: 'counter' }];   /* our tables are 30 in (owner 2026-10-18) */
    if (dw._uppTH == null) dw._uppTH = 1;
    var T = HEIGHTS[dw._uppTH];
    var alone = withTable === 'alone';
    if (alone) withTable = false;
    var VW = 600, VH = 480, floorY = 432, s = (floorY - 52) / (withTable ? 48 : 67);
    /* alone: no figure to fit, so the piece fills the frame (at most 270 px high, 400 px wide) */
    /* low consoles (media consoles, 28 in or lower) carry a 65 in TV on a centre stand as the reference (owner 2026-10-18) */
    var TV = alone && dw._uppKind === 'console' && dm.h <= 28 ? { w: 57.1, h: 32.7, st: 2.6 } : null;
    if (alone) s = TV ? Math.min(300 / (dm.h + TV.st + TV.h), 400 / Math.max(dm.w, TV.w)) : Math.min(270 / dm.h, 400 / dm.w);
    /* consoles (owner 2026-10-18): one fixed scale, the wall shown is always 10 ft wide (labelled along the bottom), so a
       bigger size draws a bigger console; a light switch at the standard 48 in sits on the wall beside it */
    var WALL = alone && dw._uppKind === 'console' ? 120 : 0;
    if (WALL) s = VW / WALL;
    var u = function (v) { return v * s; }, fy = function (h) { return floorY - h * s; };
    var near = !!dw._uppNear, out = [];
    var img = function (src, x, y, w, h, extra) {
      out.push('<image data-upp-lazy data-src="' + src + '" x="' + r(x) + '" y="' + r(y) + '" width="' + r(w) + '" height="' + r(h) + '" preserveAspectRatio="' + (extra || 'xMidYMax meet') + '"' + (near ? ' href="' + src + '"' : '') + '/>');
    };
    var txt = function (x, y, t, cls, anchor) { out.push('<text class="upp-pdp-dw__e' + cls + '" x="' + r(x) + '" y="' + r(y) + '" text-anchor="' + (anchor || 'middle') + '">' + t + '</text>'); };
    img(dw.getAttribute('data-room-front'), 0, 0, VW, VH, 'xMidYMid slice');
    /* person */
    var ph = u(67), pw = ph * 0.2, px = withTable ? 54 : 84;
    if (!alone) {
      img(dw.getAttribute('data-person-src'), px - pw / 2, fy(67), pw, ph);
      txt(8, floorY + 30, 'Person ' + two('5 ft 7 in', '170 cm'), 'ref', 'start');
    }
    /* chair */
    var cw = u(dm.w), ch = u(dm.h), cx = alone ? VW / 2 - cw / 2 : withTable ? 322 - cw / 2 : Math.max(140, Math.min(VW - 120 - cw, 380 - cw / 2));
    if (withTable) img(fr.src, cx, fy(dm.h), cw, ch, 'none');
    else out.push(this.photoSvg(fr, cx, fy(dm.h), cw, ch, near));
    if (TV) {
      var tvx = VW / 2 - u(TV.w) / 2, tvy = fy(dm.h + TV.st + TV.h);
      out.push('<rect x="' + r(VW / 2 - u(5)) + '" y="' + r(fy(dm.h) - u(0.6)) + '" width="' + r(u(10)) + '" height="' + r(u(0.6)) + '" fill="#1E1E20"/>');
      out.push('<rect x="' + r(VW / 2 - u(1.2)) + '" y="' + r(fy(dm.h + TV.st)) + '" width="' + r(u(2.4)) + '" height="' + r(u(TV.st)) + '" fill="#1E1E20"/>');
      out.push('<rect x="' + r(tvx) + '" y="' + r(tvy) + '" width="' + r(u(TV.w)) + '" height="' + r(u(TV.h)) + '" fill="#141416"/>');
      out.push('<rect x="' + r(tvx + u(0.4)) + '" y="' + r(tvy + u(0.4)) + '" width="' + r(u(TV.w - 0.8)) + '" height="' + r(u(TV.h - 1.2)) + '" fill="#2B2E33"/>');
      out.push('<text class="upp-pdp-dw__eref" style="fill:#E8E1D6" x="' + r(VW / 2) + '" y="' + r(tvy + u(TV.h) / 2 + 6) + '" text-anchor="middle">65 in TV · ' + (mt ? '145 cm' : '57 in') + ' wide</text>');
    }
    /* width under the chair, below the floor line (the table-height line runs above it) */
    var wy = WALL ? floorY + 1 : floorY + 8, wt = WALL ? floorY + 22 : floorY + 38;
    out.push('<path d="M' + r(cx) + ' ' + wy + 'v12M' + r(cx) + ' ' + (wy + 6) + 'H' + r(cx + cw) + 'M' + r(cx + cw) + ' ' + wy + 'v12" stroke="' + INK + '" stroke-width="1.5" fill="none"/>');
    txt(cx + cw / 2, wt, len(dm.w, dm.wc), 'dim');
    if (WALL) {
      /* wall width along the bottom edge, the label in a gap in the middle of the line */
      var wl = 'Wall shown: ' + two('10 ft', '305 cm') + ' wide', gapW = 118, ly = VH - 9;
      out.push('<path d="M6 ' + (ly - 5) + 'v10M6 ' + ly + 'H' + (VW / 2 - gapW) + 'M' + (VW / 2 + gapW) + ' ' + ly + 'H' + (VW - 6) + 'M' + (VW - 6) + ' ' + (ly - 5) + 'v10" stroke="' + INK + '" stroke-width="1.2" fill="none"/>');
      txt(VW / 2, ly + 5, wl, 'ref');
      /* light switch plate 2.75 x 4.5 in, centre 48 in high, 10 in beside the console (left when the right is too tight) */
      var pw = u(2.75), ph2 = u(4.5), right = cx + cw + u(10) + pw < VW - 8;
      var sx = right ? cx + cw + u(10) : cx - u(10) - pw, sy = fy(48) - ph2 / 2;
      out.push('<rect x="' + r(sx) + '" y="' + r(sy) + '" width="' + r(pw) + '" height="' + r(ph2) + '" fill="#F7F4EE" stroke="#BDB2A2" stroke-width="1"/>');
      out.push('<rect x="' + r(sx + pw * 0.38) + '" y="' + r(sy + ph2 * 0.3) + '" width="' + r(pw * 0.24) + '" height="' + r(ph2 * 0.4) + '" fill="#E4DCCF" stroke="#BDB2A2" stroke-width="0.8"/>');
      out.push('<text class="upp-pdp-dw__eref" x="' + r(right ? sx + pw : sx) + '" y="' + r(sy + ph2 + 18) + '" text-anchor="' + (right ? 'end' : 'start') + '">Switch · ' + (mt ? '122 cm' : '48 in') + '</text>');
    }
    var hLeft = !!withTable || alone;   /* chairs: height on the left (the table is on the right); consoles: on the right, text turned 90° */
    var hx = hLeft ? cx - 14 : cx + cw + 14;
    out.push('<path d="M' + r(hx - 6) + ' ' + r(fy(dm.h)) + 'h12M' + r(hx) + ' ' + r(fy(dm.h)) + 'V' + floorY + 'M' + r(hx - 6) + ' ' + floorY + 'h12" stroke="' + INK + '" stroke-width="1.5" fill="none"/>');
    /* alone: wide pieces (consoles) reach near the left edge, so the height reads turned 90° beside its line */
    if (alone) out.push('<text class="upp-pdp-dw__edim" x="' + r(hx - 14) + '" y="' + r(fy(dm.h / 2)) + '" text-anchor="middle" transform="rotate(-90 ' + r(hx - 14) + ' ' + r(fy(dm.h / 2)) + ')">' + len(dm.h, dm.hc) + '</text>');
    else if (hLeft) txt(hx - 10, fy(dm.h / 2) + 7, len(dm.h, dm.hc), 'dim', 'end');
    else out.push('<text class="upp-pdp-dw__edim" x="' + r(hx + 14) + '" y="' + r(fy(dm.h / 2)) + '" text-anchor="middle" transform="rotate(90 ' + r(hx + 14) + ' ' + r(fy(dm.h / 2)) + ')">' + len(dm.h, dm.hc) + '</text>');
    if (!withTable) {
      dw.classList.add('is-photo', 'is-roomphoto');
      svg.setAttribute('viewBox', '0 30 ' + VW + ' ' + (VH - 30));
      svg.setAttribute('preserveAspectRatio', 'xMidYMid slice');
      svg.innerHTML = out.join('');
      var inf0 = $(dw, '[data-upp-dw-info]');
      if (inf0) { inf0.hidden = false; inf0.textContent = alone ? 'Front view' + (dm.d > 0 ? ' · ' + len(dm.d, dm.dc) + ' deep' : '') + (TV ? ' · with a 65 in TV' : '') : 'Shown next to a ' + two('5 ft 7 in', '170 cm') + ' person'; }
      var cap0 = $(dw, '[data-upp-dw-cap]');
      if (cap0) cap0.textContent = 'Front view: ' + len(dm.w, dm.wc) + ' wide, ' + len(dm.h, dm.hc) + ' high' + (dm.d > 0 ? ', ' + len(dm.d, dm.dc) + ' deep' : '') + (TV ? ', with a 65 in TV on top.' : alone ? '.' : ', next to a person.');
      var oldTh = $(dw, '[data-upp-th]'); if (oldTh) oldTh.remove();
      this.lazyPhotos(dw);
      return;
    }
    /* table end at the picked height, 3 in to the right of the chair, running off the right edge */
    var tx = cx + cw + u(3), top = fy(T.h), tk = u(1.5);
    out.push('<rect x="' + r(tx) + '" y="' + r(top) + '" width="' + r(VW - tx + 4) + '" height="' + r(tk) + '" fill="' + WAL + '" stroke="' + WAL_D + '" stroke-width="1.5"/>');
    out.push('<rect x="' + r(tx + u(1.5)) + '" y="' + r(top + tk) + '" width="' + r(VW - tx) + '" height="' + r(u(3)) + '" fill="' + WAL + '" stroke="' + WAL_D + '" stroke-width="1.5"/>');
    out.push('<rect x="' + r(tx + u(2)) + '" y="' + r(top + tk) + '" width="' + r(u(2.5)) + '" height="' + r(floorY - top - tk) + '" fill="' + WAL + '" stroke="' + WAL_D + '" stroke-width="1.5"/>');
    out.push('<line x1="' + r(cx - 4) + '" y1="' + r(top) + '" x2="' + r(tx) + '" y2="' + r(top) + '" stroke="' + INK + '" stroke-width="1.5" stroke-dasharray="5 4"/>');
    /* short label over the table's own end, so it never runs over the chair (both units are in the line under the figure) */
    txt(VW - 8, top - 12, 'Table ' + (mt ? T.c + ' cm' : T.h + ' in'), 'dim', 'end');
    dw.classList.add('is-photo', 'is-roomphoto');
    svg.setAttribute('viewBox', '0 30 ' + VW + ' ' + (VH - 30));
    svg.setAttribute('preserveAspectRatio', 'xMidYMid slice');
    svg.innerHTML = out.join('');
    var inf = $(dw, '[data-upp-dw-info]');
    if (inf) { inf.hidden = false; inf.textContent = 'Next to a ' + two('5 ft 7 in', '170 cm') + ' person and a ' + (T.ours ? 'table at our ' + two(T.h + ' in', T.c + ' cm') + ' height' : two(T.h + ' in', T.c + ' cm') + (T.note ? ' counter' : ' table')); }
    var cap = $(dw, '[data-upp-dw-cap]');
    if (cap) cap.textContent = 'Front view: ' + len(dm.w, dm.wc) + ' wide, ' + len(dm.h, dm.hc) + ' high' + (dm.d > 0 ? ', ' + len(dm.d, dm.dc) + ' deep' : '') + ', next to a person and a table ' + two(T.h + ' in', T.c + ' cm') + ' high.';
    /* table-height chips, built once per figure */
    var under = $(dw, '.upp-pdp-dw__under');
    if (under && !$(dw, '[data-upp-th]')) {
      var row = document.createElement('div');
      row.className = 'upp-pdp-dw__chips upp-pdp-dw__th';
      row.setAttribute('data-upp-th', '');
      row.setAttribute('role', 'group');
      row.setAttribute('aria-label', 'Table height');
      HEIGHTS.forEach(function (H, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'upp-pdp-dw__chip';
        b.textContent = (mt ? H.c + ' cm' : H.h + ' in') + (H.ours ? ' · ours' : H.note ? ' · ' + H.note : '');
        b.addEventListener('click', function () { dw._uppTH = i; self.drawChairRoom(dw, svg, dm, fr, true); });
        row.appendChild(b);
      });
      under.appendChild(row);
      var hint = $(dw, '.upp-pdp-dw__hint'); if (hint) hint.hidden = true;
    }
    $$(dw, '[data-upp-th] .upp-pdp-dw__chip').forEach(function (b, i) { b.setAttribute('aria-pressed', i === dw._uppTH ? 'true' : 'false'); });
    if (!near && !dw._uppIoP && 'IntersectionObserver' in window) {
      dw._uppIoP = new IntersectionObserver(function (entries) {
        if (!entries.some(function (e) { return e.isIntersecting; })) return;
        dw._uppIoP.disconnect(); dw._uppNear = true;
        $$(dw, '[data-upp-lazy]').forEach(function (im) { im.setAttribute('href', im.getAttribute('data-src')); });
      }, { rootMargin: '400px' });
      dw._uppIoP.observe(dw);
    } else if (!near && !('IntersectionObserver' in window)) {
      dw._uppNear = true;
      $$(dw, '[data-upp-lazy]').forEach(function (im) { im.setAttribute('href', im.getAttribute('data-src')); });
    }
  };

  /* A product photo in the drawing at an exact W x H: stretched when that bends it 25% or less, otherwise the two
     ends (22% each, legs) keep their shape and only the middle stretches (nested svg slices). Lazy like the person. */
  Pdp.prototype.photoSvg = function (ph, x, y, w, h, near) {
    var r = function (v) { return Math.round(v * 100) / 100; };
    var img = function (ix, iw, clip) { return '<image data-upp-lazy data-src="' + ph.src + '"' + (near ? ' href="' + ph.src + '"' : '') + ' x="' + r(ix) + '" y="' + r(y) + '" width="' + r(iw) + '" height="' + r(h) + '" preserveAspectRatio="none"' + (clip ? ' clip-path="url(#' + clip + ')"' : '') + '/>'; };
    var tr = w / h;
    if (Math.abs(ph.ar - tr) <= 0.25 * tr) return img(x, w, null);
    /* slices without nested svg (the drawing's CSS sizes every svg): each slice is the whole photo, placed and scaled so
       its part lands in the slice box, clipped to that box */
    var k = h / 100, W0 = ph.ar * 100, e = W0 * 0.22, eT = e * k;
    if (2 * eT >= w) return img(x, w, null);
    var id = 'uppSl' + (Pdp._sl = (Pdp._sl || 0) + 1), sx = (w - 2 * eT) / (W0 - 2 * e);
    var clip = function (n, cx, cw) { return '<clipPath id="' + id + n + '"><rect x="' + r(cx) + '" y="' + r(y) + '" width="' + r(cw) + '" height="' + r(h) + '"/></clipPath>'; };
    return '<defs>' + clip('a', x, eT) + clip('b', x + eT, w - 2 * eT) + clip('c', x + w - eT, eT) + '</defs>' +
      img(x, W0 * k, id + 'a') +
      img(x + eT - e * sx, W0 * sx, id + 'b') +
      img(x + w - W0 * k, W0 * k, id + 'c');
  };

  Pdp.prototype.lazyPhotos = function (dw) {
    var fill = function () { dw._uppNear = true; $$(dw, '[data-upp-lazy]').forEach(function (im) { if (!im.getAttribute('href')) im.setAttribute('href', im.getAttribute('data-src')); }); };
    if (dw._uppNear) { fill(); return; }
    if (dw._uppIoP) return;
    if (!('IntersectionObserver' in window)) { fill(); return; }
    dw._uppIoP = new IntersectionObserver(function (entries) {
      if (!entries.some(function (en) { return en.isIntersecting; })) return;
      dw._uppIoP.disconnect(); fill();
    }, { rootMargin: '400px' });
    dw._uppIoP.observe(dw);
  };

  /* Coffee / nesting tables in front of a standard 84 x 34 in sofa (seat 18 in), 17 in apart; side / end tables beside
     its right arm, 2 in away. Top: front view in the empty room; below: the same seen from above on the floor. */
  Pdp.prototype.drawSofaScene = function (dw, svg, dm, E, K) {
    var self = this, r = function (v) { return Math.round(v * 10) / 10; };
    var len = function (i, c) { return self.len(i, c); };
    var mt = this.data.metric, two = function (i, c) { return mt ? c + ' (' + i + ')' : i + ' (' + c + ')'; };
    var INK = '#1A1512', FLOOR = '#F3ECE0', near = !!dw._uppNear, out = [];
    var SW = 84, SH = 34, SD = 36, GAP = K === 'side' ? 2 : 17;
    var VW = 600, P1 = 380, VH = 680;
    var txt = function (x, y, t, cls, anchor) { out.push('<text class="upp-pdp-dw__e' + cls + '" x="' + r(x) + '" y="' + r(y) + '" text-anchor="' + (anchor || 'middle') + '">' + t + '</text>'); };
    var dimH = function (x1, x2, y, t) { out.push('<path d="M' + r(x1) + ' ' + r(y - 6) + 'v12M' + r(x1) + ' ' + r(y) + 'H' + r(x2) + 'M' + r(x2) + ' ' + r(y - 6) + 'v12" stroke="' + INK + '" stroke-width="1.5" fill="none"/>'); txt((x1 + x2) / 2, y + 22, t, 'dim'); };
    var dimV = function (x, y1, y2, t, side) { out.push('<path d="M' + r(x - 6) + ' ' + r(y1) + 'h12M' + r(x) + ' ' + r(y1) + 'V' + r(y2) + 'M' + r(x - 6) + ' ' + r(y2) + 'h12" stroke="' + INK + '" stroke-width="1.5" fill="none"/>'); txt(side === 'l' ? x - 10 : x + 10, (y1 + y2) / 2 + 7, t, 'dim', side === 'l' ? 'end' : 'start'); };
    var sofa = { src: dw.getAttribute('data-sofa-front'), ar: SW / SH }, sofaTop = { src: dw.getAttribute('data-sofa-top'), ar: SW / SD };
    /* front view: room photo cropped to the panel, floor line at y 332 */
    out.push('<defs><clipPath id="uppSofaP1"><rect x="0" y="0" width="' + VW + '" height="' + P1 + '"/></clipPath></defs>');
    out.push('<g clip-path="url(#uppSofaP1)"><image data-upp-lazy data-src="' + dw.getAttribute('data-room-front') + '"' + (near ? ' href="' + dw.getAttribute('data-room-front') + '"' : '') + ' x="0" y="-100" width="' + VW + '" height="480" preserveAspectRatio="xMidYMid slice"/></g>');
    var floorY = 332;
    /* front view: the piece alone, filling the panel (owner 2026-10-18: no sofa in the front view; the plan below keeps it) */
    var s = K === 'side' ? Math.min(4.8, (VW - 120) / (SW + GAP + dm.w)) : Math.min(4.8, (VW - 80) / Math.max(SW, dm.w));
    var sF = Math.min((VW - 160) / dm.w, (floorY - 70) / dm.h);
    var u = function (v) { return v * sF; };
    var tx = (VW - u(dm.w)) / 2;
    out.push(this.photoSvg(E.fr, tx, floorY - u(dm.h), u(dm.w), u(dm.h), near));
    dimH(tx, tx + u(dm.w), floorY + 16, len(dm.w, dm.wc));
    /* height: tick on the right of the piece, text turned 90° so it never leaves the frame */
    var hx2 = tx + u(dm.w) + 12;
    out.push('<path d="M' + r(hx2 - 6) + ' ' + r(floorY - u(dm.h)) + 'h12M' + r(hx2) + ' ' + r(floorY - u(dm.h)) + 'V' + r(floorY) + 'M' + r(hx2 - 6) + ' ' + r(floorY) + 'h12" stroke="' + INK + '" stroke-width="1.5" fill="none"/>');
    out.push('<text class="upp-pdp-dw__edim" x="' + r(hx2 + 14) + '" y="' + r(floorY - u(dm.h) / 2) + '" text-anchor="middle" transform="rotate(90 ' + r(hx2 + 14) + ' ' + r(floorY - u(dm.h) / 2) + ')">' + len(dm.h, dm.hc) + '</text>');
    /* plan view */
    var y0 = P1 + 12;
    out.push('<rect x="0" y="' + y0 + '" width="' + VW + '" height="' + (VH - y0) + '" fill="' + FLOOR + '"/>');
    txt(20, y0 + 26, 'Seen from above', 'ref', 'start');
    var d2 = dm.d || dm.w;
    var s2 = K === 'side' ? Math.min(s, (VW - 120) / (SW + GAP + dm.w), (VH - y0 - 90) / Math.max(SD, d2)) : Math.min(s, (VW - 80) / Math.max(SW, dm.w), (VH - y0 - 100) / (SD + GAP + d2));
    var u2 = function (v) { return v * s2; };
    var px = K === 'side' ? (VW - u2(SW + GAP + dm.w)) / 2 : (VW - u2(SW)) / 2, py = y0 + 46;
    out.push(this.photoSvg(sofaTop, px, py, u2(SW), u2(SD), near));
    var top = E.tp || null, ttx, tty;
    if (K === 'side') { ttx = px + u2(SW + GAP); tty = py + (u2(SD) - u2(d2)) / 2; }
    else { ttx = (VW - u2(dm.w)) / 2; tty = py + u2(SD + GAP); }
    if (top) out.push('<image data-upp-lazy data-src="' + top.src + '"' + (near ? ' href="' + top.src + '"' : '') + ' x="' + r(ttx) + '" y="' + r(tty) + '" width="' + r(u2(dm.w)) + '" height="' + r(u2(d2)) + '" preserveAspectRatio="none"/>');
    else out.push('<rect x="' + r(ttx) + '" y="' + r(tty) + '" width="' + r(u2(dm.w)) + '" height="' + r(u2(d2)) + '" rx="4" fill="#6B4A2E"/>');
    dimH(ttx, ttx + u2(dm.w), tty + u2(d2) + 12, len(dm.w, dm.wc) + (dm.d ? ' × ' + len(dm.d, dm.dc) : ''));
    if (K !== 'side') dimV(ttx - 12, py + u2(SD), tty, len(GAP, 43), 'l');
    dw.classList.add('is-photo', 'is-sofa');
    svg.setAttribute('viewBox', '0 0 ' + VW + ' ' + VH);
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    svg.innerHTML = out.join('');
    var inf = $(dw, '[data-upp-dw-info]');
    if (inf) { inf.hidden = false; inf.textContent = K === 'side' ? 'From above: beside a standard ' + two('84 in', '213 cm') + ' sofa' : 'From above: in front of a standard ' + two('84 in', '213 cm') + ' sofa, ' + two('17 in', '43 cm') + ' apart'; }
    var cap = $(dw, '[data-upp-dw-cap]');
    if (cap) cap.textContent = (dm.nested ? 'Set of ' + dm.nested + ', nested: ' : '') + len(dm.w, dm.wc) + ' wide, ' + len(dm.h, dm.hc) + ' high' + (dm.d ? ', ' + len(dm.d, dm.dc) + ' deep' : '') + '. Front view, then seen from above ' + (K === 'side' ? 'beside' : 'in front of') + ' a standard 84 in sofa.';
    this.lazyPhotos(dw);
  };

  /* Everything else with photos: the front view, then the top view, on white, one scale; no person (owner 2026-10-18),
     so the two views fill the frame (piece at most 300 px high). */
  Pdp.prototype.drawTwoViews = function (dw, svg, dm, E) {
    var self = this, r = function (v) { return Math.round(v * 10) / 10; };
    var len = function (i, c) { return self.len(i, c); };
    var mt = this.data.metric, two = function (i, c) { return mt ? c + ' (' + i + ')' : i + ' (' + c + ')'; };
    var INK = '#1A1512', near = !!dw._uppNear, out = [];
    var VW = 600, d2 = dm.d || 0, hasTop = !!(E.tp && d2 > 0);
    var widthIn = dm.w + (hasTop ? 16 + dm.w : 0) + 12;
    var s = Math.min((VW - 60) / widthIn, 300 / Math.max(dm.h, hasTop ? d2 : 0));
    var u = function (v) { return v * s; };
    var floorY = 46 + Math.max(u(dm.h), hasTop ? (u(dm.h) + u(d2)) / 2 : 0), VH = Math.ceil(floorY + 50);
    var txt = function (x, y, t, cls, anchor) { out.push('<text class="upp-pdp-dw__e' + cls + '" x="' + r(x) + '" y="' + r(y) + '" text-anchor="' + (anchor || 'middle') + '">' + t + '</text>'); };
    var dimH = function (x1, x2, y, t) { out.push('<path d="M' + r(x1) + ' ' + r(y - 6) + 'v12M' + r(x1) + ' ' + r(y) + 'H' + r(x2) + 'M' + r(x2) + ' ' + r(y - 6) + 'v12" stroke="' + INK + '" stroke-width="1.5" fill="none"/>'); txt((x1 + x2) / 2, y + 22, t, 'dim'); };
    var x0 = (VW - u(widthIn)) / 2;
    out.push('<line x1="10" y1="' + r(floorY) + '" x2="' + (VW - 10) + '" y2="' + r(floorY) + '" stroke="#C9BBA6" stroke-width="1.5"/>');
    var fx = x0;
    out.push(this.photoSvg(E.fr, fx, floorY - u(dm.h), u(dm.w), u(dm.h), near));
    dimH(fx, fx + u(dm.w), floorY + 14, len(dm.w, dm.wc));
    var hx = fx + u(dm.w) + 10;
    out.push('<path d="M' + r(hx - 6) + ' ' + r(floorY - u(dm.h)) + 'h12M' + r(hx) + ' ' + r(floorY - u(dm.h)) + 'V' + r(floorY) + 'M' + r(hx - 6) + ' ' + r(floorY) + 'h12" stroke="' + INK + '" stroke-width="1.5" fill="none"/>');
    out.push('<text class="upp-pdp-dw__edim" x="' + r(hx + 10) + '" y="' + r(floorY - u(dm.h) / 2) + '" text-anchor="middle" transform="rotate(90 ' + r(hx + 10) + ' ' + r(floorY - u(dm.h) / 2) + ')">' + len(dm.h, dm.hc) + '</text>');
    txt(fx + u(dm.w) / 2, floorY - u(dm.h) - 10, 'Front', 'ref');
    if (hasTop) {
      var tx = fx + u(dm.w + 16), ty = floorY - u(dm.h) / 2 - u(d2) / 2;
      out.push('<image data-upp-lazy data-src="' + E.tp.src + '"' + (near ? ' href="' + E.tp.src + '"' : '') + ' x="' + r(tx) + '" y="' + r(ty) + '" width="' + r(u(dm.w)) + '" height="' + r(u(d2)) + '" preserveAspectRatio="none"/>');
      txt(tx + u(dm.w) / 2, ty - 10, 'Seen from above', 'ref');
      dimH(tx, tx + u(dm.w), floorY + 14, len(dm.w, dm.wc) + ' × ' + len(d2, dm.dc));
    }
    dw.classList.add('is-photo');
    svg.setAttribute('viewBox', '0 0 ' + VW + ' ' + VH);
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
    svg.innerHTML = out.join('');
    var inf = $(dw, '[data-upp-dw-info]');
    if (inf) { inf.hidden = false; inf.textContent = hasTop ? 'Front and top view, drawn to scale' : 'Front view, drawn to scale'; }
    var cap = $(dw, '[data-upp-dw-cap]');
    if (cap) cap.textContent = 'Front view ' + len(dm.w, dm.wc) + ' wide and ' + len(dm.h, dm.hc) + ' high' + (hasTop ? ', top view ' + len(dm.w, dm.wc) + ' by ' + len(d2, dm.dc) : '') + '.';
    this.lazyPhotos(dw);
  };

  /* ---------- Size chips on the drawing tile ----------
     A row of the sizes inside the gallery's drawing slide, so another size can be tried without
     scrolling to the buy box. A chip checks the matching buy-box radio and fires its change event
     (the normal variant path: URL, price, sticky bar, dialog, both drawings); holdMedia keeps the
     gallery on the drawing. The row is its own horizontal scroller (overscroll contained), and
     touch / pointer events stop at it so a swipe there never moves the gallery track. */
  Pdp.prototype.initDrawChips = function () {
    var self = this, idx = this.data.sizeIdx, sizes = this.data.sizes || [];
    var dw = $(this.root, '[data-upp-gallery] [data-upp-dw]');
    if (!dw || idx == null || idx < 0 || sizes.length < 2) return;
    var under = $(dw, '.upp-pdp-dw__under');
    if (!under) return;
    var row = document.createElement('div');
    row.className = 'upp-pdp-dw__chips';
    row.setAttribute('data-upp-dw-chips', '');
    row.setAttribute('role', 'group');
    row.setAttribute('aria-label', 'Try another size');
    sizes.forEach(function (sz) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'upp-pdp-dw__chip';
      b.setAttribute('data-value', sz.value);
      b.textContent = sz.name && !sz.in ? sz.name : (sz.name ? sz.name + ' · ' : '') + (sz.in ? self.dim(sz.in, sz.cm, 'first') : sz.value);
      b.addEventListener('click', function () {
        var main = self.optionInputs.filter(function (m) { return Number(m.getAttribute('data-upp-opt-input')) === idx && m.value === sz.value; })[0];
        if (!main || main.checked) return;
        main.checked = true;
        self.holdMedia = true;
        try { main.dispatchEvent(new Event('change', { bubbles: true })); } finally { self.holdMedia = false; }
      });
      row.appendChild(b);
    });
    ['touchstart', 'touchmove', 'pointerdown', 'wheel'].forEach(function (t) {
      row.addEventListener(t, function (e) { e.stopPropagation(); }, { passive: true });
    });
    under.appendChild(row);
    dw.classList.add('has-chips');
    /* a row that fits can't scroll, so it takes no horizontal pan at all (is-fit: touch-action pan-y) */
    var fit = function () { row.classList.toggle('is-fit', row.scrollWidth <= row.clientWidth + 1); };
    var sync = function (v) {
      $$(row, '.upp-pdp-dw__chip').forEach(function (b) {
        var on = v && v.options[idx] === b.getAttribute('data-value');
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on && row.scrollWidth > row.clientWidth) {
          var l = b.offsetLeft, r = l + b.offsetWidth;   /* row is position: relative */
          if (l < row.scrollLeft || r > row.scrollLeft + row.clientWidth) row.scrollLeft = l - 16;
        }
      });
    };
    this.root.addEventListener('upp:variant-change', function (e) { sync(e.detail && e.detail.variant); });
    sync(this.variant);
    fit();
    window.addEventListener('resize', fit);
  };

  /* ---------- Stock status row (snippets/upp-pdp-status) ----------
     Follows the chosen variant: v.lt.m (stock | mto | sold | ship) and the build part of v.lt.short.
     Same wording as the snippet. */
  Pdp.prototype.initStatus = function () {
    var row = $(this.root, '[data-upp-status]');
    if (!row) return;
    var rts = row.getAttribute('data-rts') === 'true', place = row.getAttribute('data-place') || 'Fairfield, NJ showroom';
    /* "or N weeks with Expedite" only when the Expedite line can be added (addons.exp is null when the add-on product is missing or unavailable; review 2026-10-18) */
    var canExp = !!(this.data.addons && this.data.addons.exp);
    this.root.addEventListener('upp:variant-change', function (e) {
      var v = e.detail && e.detail.variant, lt = v && v.lt;
      if (!lt) return;
      var text = '';
      if (lt.m === 'stock') text = 'In stock' + (rts ? ' · ' + place : '');
      else if (lt.m === 'sold') text = 'Sold';
      else if (lt.m === 'mto') {
        /* words from lt.short ("About 6 weeks to build, …": the owner's figures; lt.o.*.p is padded for dates) */
        var build = String(lt.short || '').split(' to build')[0].trim().toLowerCase();
        text = 'Made to order' + (build && build !== String(lt.short || '').toLowerCase() && build.indexOf('about') > -1 ? ' · ships in ' + build + (lt.xw && canExp ? ', or ' + lt.xw + ' with Expedite' : '') : '');
      }
      row.setAttribute('data-mode', lt.m);
      row.hidden = !text;
      $(row, '[data-upp-status-text]').textContent = text;
    });
  };

  /* ---------- Custom furniture links ----------
     [data-upp-custom] links carry ?design / piece / wood for the custom request form
     (snippets/upp-custom-link). When the product has a wood / colour option (data.customWoodIdx),
     wood follows the chosen variant: the wood its value names, else data.customWoodFallback
     (custom.wood_type), else no wood param. */
  Pdp.prototype.initCustomLinks = function () {
    var idx = this.data.customWoodIdx, root = this.root;
    if (idx == null || idx < 0) return;
    /* only a value that names a wood counts (same list as snippets/upp-custom-link) */
    var WOODS = ['walnut', 'chestnut', 'oak', 'spruce', 'beech', 'cedar', 'oleaster'];
    var fallback = this.data.customWoodFallback || '';
    root.addEventListener('upp:variant-change', function (e) {
      var v = e.detail && e.detail.variant, raw = String((v && v.options[idx]) || '').toLowerCase();
      var hit = WOODS.filter(function (w) { return raw.indexOf(w) > -1; })[0];
      var val = hit ? hit.charAt(0).toUpperCase() + hit.slice(1) : fallback;
      $$(root, '[data-upp-custom]').forEach(function (a) {
        try {
          var u = new URL(a.getAttribute('href'), window.location.origin);
          if (val) u.searchParams.set('wood', val); else u.searchParams.delete('wood');
          a.setAttribute('href', u.pathname + u.search);
        } catch (err) { /* leave the link as it is */ }
      });
    });
  };

  /* ---------- Size guide dialog ----------
     The legend's "Size guide" link (a jump to the spec table without JS) opens a modal <dialog>:
     a second copy of the gallery's drawing (drawn by drawSizeIn like the tile) beside a copy of the
     size buttons. Built on first open, which is also when its room photo loads. A size picked there
     checks the matching buy-box radio and fires its change event, so the normal variant path runs
     (URL, price, gallery, sticky bar, chairs, both drawings); the copy's radios follow
     upp:variant-change. The copy keeps data-upp-option / data-upp-opt-input, so setVariant also keeps
     its prices and availability current. Only when the page has the drawing and the size option. */
  Pdp.prototype.initSizeGuide = function () {
    var self = this, link = $(this.root, '[data-upp-guide]');
    if (!link || !window.HTMLDialogElement || !$(this.root, '[data-upp-gallery] [data-upp-dw]')) return;
    link.setAttribute('role', 'button');
    link.setAttribute('aria-haspopup', 'dialog');
    link.addEventListener('click', function (e) { e.preventDefault(); self.openSizeGuide(link); });
    link.addEventListener('keydown', function (e) { if (e.key === ' ') { e.preventDefault(); self.openSizeGuide(link); } });
  };

  Pdp.prototype.openSizeGuide = function (link) {
    if (!this.sg) this.sg = this.buildSizeGuide(link);
    this.sg.dialog._uppReturn = link;
    $$(this.sg.dialog, '[data-upp-error]').forEach(function (e) { e.hidden = true; });
    this.sg.syncSum();
    document.documentElement.classList.add('upp-sg-open');
    this.sg.dialog.showModal();
    var on = $(this.sg.dialog, '.upp-pdp-sg__sizes input:checked') || $(this.sg.dialog, '.upp-pdp-sg__sizes input');
    if (on) on.focus();
  };

  Pdp.prototype.buildSizeGuide = function (link) {
    var self = this, root = this.root;
    var sid = root.getAttribute('data-section-id') || 'x';
    var srcDw = $(root, '[data-upp-gallery] [data-upp-dw]');
    var srcFs = link.closest('[data-upp-option]');
    var x = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 5l14 14M19 5L5 19"/></svg>';
    var d = document.createElement('dialog');
    d.className = 'upp-pdp-sg';
    d.setAttribute('aria-labelledby', 'UppSgTitle-' + sid);
    d.innerHTML =
      '<div class="upp-pdp-sg__inner">' +
        '<div class="upp-pdp-sg__draw"></div>' +
        '<div class="upp-pdp-sg__side">' +
          '<div class="upp-pdp-sg__head"><h2 class="upp-pdp-sg__title" id="UppSgTitle-' + sid + '">Size guide</h2>' +
          '<button type="button" class="upp-pdp-sg__close" data-upp-sg-close aria-label="Close size guide">' + x + '</button></div>' +
          '<div class="upp-pdp-sg__sizes"></div>' +
          '<p class="upp-pdp-sg__sum" data-upp-sg-sum aria-live="polite"></p>' +
          '<div class="upp-pdp-sg__foot">' +
            '<p class="upp-pdp-form__error upp-pdp-sg__error" data-upp-error role="alert" hidden></p>' +
            '<button type="button" class="upp-btn upp-pdp-sg__atc" data-upp-sg-atc><span data-upp-sg-atc-label>Add to cart</span> <span data-upp-sg-atc-price></span></button>' +
          '</div>' +
        '</div>' +
      '</div>';

    /* drawing copy: own ids, photo loads now */
    var dw = srcDw.cloneNode(true);
    $$(dw, '[data-upp-th]').forEach(function (n) { n.remove(); });   /* table-height chips: the copy builds its own (listeners don't clone) */
    var chips = $(dw, '[data-upp-dw-chips]');
    if (chips) chips.parentNode.removeChild(chips);   /* the dialog has the size buttons */
    dw.classList.remove('has-chips');
    var cap = $(dw, '[data-upp-dw-cap]'), svg = $(dw, 'svg');
    if (cap) cap.id = 'UppDwCap-sg-' + sid;
    if (svg && cap) svg.setAttribute('aria-labelledby', cap.id);
    dw._uppNear = true;
    $(d, '.upp-pdp-sg__draw').appendChild(dw);

    /* size buttons copy: own radio group, no link (none when the product has no Size buttons) */
    var fs = srcFs ? srcFs.cloneNode(true) : document.createElement('div');
    var g = $(fs, '[data-upp-guide]');
    if (g) g.parentNode.removeChild(g);
    $$(fs, '[data-upp-opt-input]').forEach(function (input) {
      var lab = input.closest('label');
      input.name = input.name + '-sg';
      input.id = input.id + '-sg';
      if (lab) lab.setAttribute('for', input.id);
      input.addEventListener('change', function () {
        if (!input.checked) return;
        var oi = input.getAttribute('data-upp-opt-input');
        var main = self.optionInputs.filter(function (m) { return m.getAttribute('data-upp-opt-input') === oi && m.value === input.value; })[0];
        if (!main || main.checked) return;
        main.checked = true;
        main.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    $(d, '.upp-pdp-sg__sizes').appendChild(fs);

    root.appendChild(d);
    if (this.sizeNow) this.drawSizeIn(dw, this.sizeNow);

    var sum = $(d, '[data-upp-sg-sum]');
    var syncSum = function () {
      var info = self.sizeNow || {};
      var parts = [];
      if (info.in || info.value) parts.push((info.name ? info.name + ' · ' : '') + (info.in ? self.dim(info.in, info.cm, 'paren') : info.value));
      if (info.seats) parts.push('seats ' + info.seats);
      if (self.variant) parts.push(self.money(self.variant.price));
      sum.textContent = parts.join(' · ');
    };
    root.addEventListener('upp:variant-change', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v) return;
      $$(fs, '[data-upp-opt-input]').forEach(function (input) {
        input.checked = v.options[Number(input.getAttribute('data-upp-opt-input'))] === input.value;
      });
      syncSum();
    });

    var close = function () { d.close(); };
    $$(d, '[data-upp-sg-close]').forEach(function (b) { b.addEventListener('click', close); });
    /* Add to cart: the buy box's own add(); on success the dialog closes so the cart drawer
       (opened by the same ajaxProduct:added event) is on top and keeps the focus. */
    this.sgAtc = $(d, '[data-upp-sg-atc]');
    this.sgAtc.addEventListener('click', function () { self.add(); });
    if (this.form) this.form.addEventListener('ajaxProduct:added', function () {
      if (!d.open) return;
      d._uppReturn = null;
      d.close();
    });
    this.updateButtons();
    d.addEventListener('click', function (e) { if (e.target === d) close(); });
    d.addEventListener('close', function () {
      document.documentElement.classList.remove('upp-sg-open');
      if (d._uppReturn && d._uppReturn.focus) d._uppReturn.focus();
    });
    d._uppReturn = link;
    return { dialog: d, syncSum: syncSum };
  };

  Pdp.prototype.qty = function () {
    var q = $(this.root, '[data-upp-qty]');
    var n = q ? parseInt(q.value, 10) : 1;
    return isNaN(n) || n < 1 ? 1 : n;
  };

  /* a chair style is chosen on one of the set cards (initSet) */
  Pdp.prototype.setOn = function () {
    return !!(this.data.set && this.setPick && this.data.set.variantId);
  };

  Pdp.prototype.chairCount = function () {
    var c = $(this.root, '[data-upp-set-count]');
    var n = c ? parseInt(c.value, 10) : 0;
    var max = c ? parseInt(c.getAttribute('max'), 10) || 12 : 12;
    if (isNaN(n) || n < 1) n = 1;
    return Math.min(n, max);
  };

  /* Fee of the selected delivery add-on: Expedite per piece (x qty), White glove once per order. */
  Pdp.prototype.addonFee = function () {
    var a = this.data.addons || {}, opt = this.deliveryOption();
    if (opt === 'exp' && a.exp && a.expPrice) return { amt: a.expPrice * this.qty(), word: 'expedite' };
    if (opt === 'wg' && a.wg && a.wgPrice) return { amt: a.wgPrice, word: 'white glove' };
    return null;
  };

  Pdp.prototype.updateButtons = function () {
    var v = this.variant, root = this.root;
    var total = v.price * this.qty();
    if (this.setOn()) total += this.data.set.price * this.chairCount();
    var fee = v.available ? this.addonFee() : null;
    var feeTxt = fee ? ' + ' + this.money(fee.amt) + ' ' + fee.word : '';
    var label = $(root, '[data-upp-atc-label]');
    var price = $(root, '[data-upp-atc-price]');
    if (this.atc) {
      this.atc.disabled = !v.available;
      if (label) label.textContent = v.available ? (this.setOn() ? 'Add set to cart' : 'Add to cart') : 'Sold out';
      if (price) { price.hidden = !v.available; price.textContent = '· ' + this.money(total) + feeTxt; }
    }
    var dyn = $(root, '[data-upp-dyn]');
    if (dyn) dyn.hidden = this.setOn() || !v.available;
    var sgb = this.sgAtc;
    if (sgb) {
      sgb.disabled = !v.available;
      $(sgb, '[data-upp-sg-atc-label]').textContent = v.available ? (this.setOn() ? 'Add set to cart' : 'Add to cart') : 'Sold out';
      $(sgb, '[data-upp-sg-atc-price]').textContent = v.available ? '· ' + this.money(total) + feeTxt : '';
    }
    var barBtn = $(root, '[data-upp-bar-btn]');
    if (barBtn) { barBtn.disabled = !v.available; barBtn.textContent = v.available ? 'Add to cart' : 'Sold out'; }
    var barPrice = $(root, '[data-upp-bar-price]');
    if (barPrice) barPrice.textContent = this.money(total) + (fee ? ' + ' + this.money(fee.amt) : '');
    /* sticky bar: the struck price only for the piece alone (no chairs, no add-on fee, quantity 1) */
    var barCmp = $(root, '[data-upp-bar-compare]');
    if (barCmp) {
      var showBar = v.compare > v.price && !this.setOn() && !fee && this.qty() === 1;
      barCmp.hidden = !showBar;
      if (showBar) $(barCmp, '[data-upp-bar-compare-amount]').textContent = this.money(v.compare);
    }
  };

  /* ---------- Steppers ---------- */
  Pdp.prototype.initSteppers = function () {
    var self = this;
    $$(this.root, '.upp-pdp-stepper').forEach(function (st) {
      var input = $(st, 'input');
      $$(st, '[data-upp-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var min = parseInt(input.getAttribute('min'), 10) || 1;
          var max = parseInt(input.getAttribute('max'), 10) || 99;
          var n = (parseInt(input.value, 10) || min) + Number(btn.getAttribute('data-upp-step'));
          input.value = Math.max(min, Math.min(max, n));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      input.addEventListener('change', function () { self.updateButtons(); });
    });
  };

  /* ---------- Matching chairs ---------- */
  /* ---------- Matching chairs (cards) ----------
     Up to 3 chair styles for the selected variant (window.uppChairMatch over data.set.chairs, from
     snippets/upp-chair-match): same wood first (else best sellers, tagged "Pairs well"), in stock
     first, then the collection order. A card's Add button chooses that style for the set (pressed
     again: no chairs); the main Add to cart then sends table + chairs in one /cart/add.js call.
     Count: the top of the size's seat range until the buyer changes it. */
  Pdp.prototype.initSet = function () {
    var self = this, box = $(this.root, '[data-upp-set]');
    if (!box || !this.data.set) return;
    this.setPick = null;
    $(box, '[data-upp-set-count]').addEventListener('change', function () { self.setTouched = true; self.updateSet(); });
    $(box, '[data-upp-set-cards]').addEventListener('click', function (e) {
      var b = e.target.closest('[data-upp-set-add]');
      if (!b) return;
      var h = b.getAttribute('data-upp-set-add');
      self.setPick = self.setPick === h ? null : h;
      self.updateSet();
    });
    this.updateSet();
  };

  Pdp.prototype.tableWoods = function () {
    var v = this.variant, names = this.data.set.optionNames || [], woods = [], values = [];
    (v ? v.options : []).forEach(function (val, i) {
      if (i === this.data.sizeIdx) return;
      var n = String(names[i] || '').toLowerCase();
      if (/wood|species|colou?r|finish/.test(n) && !/leg|epoxy|fabric|cushion|top/.test(n)) woods.push(val);
      values.push(val);
    }, this);
    return { woods: woods.concat(this.data.set.woods || []), values: values };
  };

  Pdp.prototype.updateSet = function () {
    var self = this, box = $(this.root, '[data-upp-set]'), set = this.data.set;
    if (box && set && window.uppChairMatch) {
      var count = $(box, '[data-upp-set-count]');
      if (!this.setTouched) {
        /* seats of the chosen size; a ready-to-ship piece (no Size option) has its own, data.set.seats */
        var info = this.data.sizeIdx > -1 ? this.sizeInfo(this.variant.options[this.data.sizeIdx]) : null;
        var seatStr = this.data.sizeIdx > -1 ? info && info.seats : set.seats;
        var nums = seatStr ? String(seatStr).match(/\d+/g) : null;
        count.value = nums ? parseInt(nums[nums.length - 1], 10) : set.fallback;
      }
      var n = this.chairCount();
      count.value = n;
      $(box, '[data-upp-set-count-text]').textContent = n;
      var tw = this.tableWoods();
      var res = window.uppChairMatch.pick(set.chairs, { woods: tw.woods, values: tw.values, max: set.styles || 3 });
      if (this.setPick && !res.items.some(function (it) { return it.chair.h === self.setPick; })) this.setPick = null;
      var chosen = null;
      /* card image widths by layout (.is-n1 / n2 / n3): 120px photo; half; a third of the buy box */
      var nCards = Math.max(1, Math.min(3, res.items.length));
      var cardSizes = nCards === 1 ? '120px' : nCards === 2 ? '(min-width: 990px) 220px, calc(42vw - 8px)' : '(min-width: 990px) 140px, 28vw';
      var allUrl = box.getAttribute('data-all-url');
      var html = res.items.map(function (it, idx) {
        var c = it.chair, v = it.variant, on = self.setPick === c.h;
        var last = idx === res.items.length - 1;
        if (on) chosen = v;
        return '<li class="upp-pdp-set__card' + (on ? ' is-on' : '') + '">' +
          '<a class="upp-pdp-set__img" href="' + c.u + '" tabindex="-1" aria-hidden="true">' + (c.img ? '<img src="' + c.img + '" srcset="' + [200, 300, 400].map(function (w) { return c.img.replace(/([?&])width=\d+/, '$1width=' + w) + ' ' + w + 'w'; }).join(', ') + '" sizes="' + cardSizes + '" alt="" loading="lazy" width="200" height="200">' : '') + '</a>' +
          (res.kind === 'pairs' ? '<span class="upp-pdp-set__tag">Pairs well</span>' : '') +
          '<a class="upp-pdp-set__name" href="' + c.u + '">' + c.t.replace(/</g, '&lt;') + '</a>' +
          '<p class="upp-pdp-set__price"><span class="upp-pdp-set__each">' + self.money(v.p) + ' each</span> · <span class="upp-pdp-set__total">' + n + ' = ' + self.money(v.p * n) + '</span></p>' +
          '<div class="upp-pdp-set__acts">' +
          '<button type="button" class="upp-pdp-set__add" data-upp-set-add="' + c.h + '" aria-pressed="' + (on ? 'true' : 'false') + '" aria-label="' + (on ? 'Added ' : 'Add ') + n + ' ' + c.t.replace(/"/g, '&quot;') + ' chairs to the set">' + (on ? 'Added' : 'Add') + '</button>' +
          (last && allUrl ? '<a class="upp-pdp-set__all" href="' + allUrl + '"><span>Shop all</span><span>seating →</span></a>' : '') +
          '</div>' +
          '</li>';
      }).join('');
      var list = $(box, '[data-upp-set-cards]');
      var focused = document.activeElement && list.contains(document.activeElement) ? document.activeElement.getAttribute('data-upp-set-add') : null;
      /* one chair style: the chair stepper sits next to that card's Add (owner 2026-10-17); 2-3 styles keep it in the head */
      var stepper = $(box, '.upp-pdp-stepper'), head = $(box, '.upp-pdp-set__head');
      var stepFocus = stepper && stepper.contains(document.activeElement) ? document.activeElement : null;
      if (stepper && stepper.parentNode !== head) head.appendChild(stepper);
      list.innerHTML = html;
      list.className = 'upp-pdp-set__cards is-n' + nCards;
      if (stepper && nCards === 1) { var acts = $(list, '.upp-pdp-set__acts'); if (acts) acts.insertBefore(stepper, acts.firstChild); }
      if (stepFocus) stepFocus.focus();
      if (focused) { var back = list.querySelector('[data-upp-set-add="' + focused + '"]'); if (back) back.focus(); }
      box.hidden = !res.items.length;
      set.variantId = chosen ? chosen.id : null;
      set.price = chosen ? chosen.p : 0;
      set.title = chosen ? res.items.filter(function (it) { return it.chair.h === self.setPick; })[0].chair.t : '';
    }
    this.updateButtons();
  };

  /* ---------- Add to cart ---------- */
  Pdp.prototype.initForm = function () {
    var self = this;
    if (!this.form) return;
    $$(this.root, '[data-upp-delivery]').forEach(function (r) {
      r.addEventListener('change', function () { self.updateEta(); self.updateButtons(); });
    });
    this.form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      self.add();
    });
  };

  /* ---------- Sample packs box (snippets/upp-pdp-samples): each row's Add puts one pack in the cart ---------- */
  Pdp.prototype.initSamples = function () {
    var self = this;
    $$(this.root, '[data-upp-rts-all]').forEach(function (b) {
      b.addEventListener('click', function () {
        var grid = b.parentNode.querySelector('.upp-rts__grid');
        if (grid) grid.classList.add('is-all');
        b.setAttribute('aria-expanded', 'true');
        b.hidden = true;
        var next = grid && grid.children[6] && grid.children[6].querySelector('button');
        if (next) next.focus();
      });
    });
    /* Ready-to-ship piece photos (snippets/upp-rts-pieces): the card photo opens that piece's photo dialog */
    $$(this.root, '[data-upp-rts-photos]').forEach(function (b) {
      var dlg = document.getElementById(b.getAttribute('data-upp-rts-photos'));
      if (!dlg || !dlg.showModal) return;
      b.addEventListener('click', function () { dlg.showModal(); });
      $$(dlg, '[data-upp-rts-close]').forEach(function (x) { x.addEventListener('click', function () { dlg.close(); }); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    });
    $$(this.root, '[data-upp-xs-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-loading') || !window.fetch) return;
        btn.classList.add('is-loading');
        var body = { items: [{ id: Number(btn.getAttribute('data-variant')), quantity: 1 }] };
        var drawerSection = window.theme && theme.cart && theme.cart.drawerSection;
        if (drawerSection) { body.sections = drawerSection; body.sections_url = window.location.pathname; }
        var routes = (window.theme && theme.routes) || {};
        var url = routes.cartAdd || '/cart/add.js';
        if (!/\.js$/.test(url)) url += '.js';
        fetch(url, {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        })
          .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
          .then(function (r) {
            btn.classList.remove('is-loading');
            if (!r.ok || r.data.status) { self.fail(r.data && (r.data.description || r.data.message)); return; }
            var dlg = btn.closest('dialog');
            if (dlg && dlg.open) dlg.close();
            var line = Object.assign({}, (r.data.items && r.data.items[0]) || {});
            line.sections = r.data.sections;
            (self.form || btn).dispatchEvent(new CustomEvent('ajaxProduct:added', {
              bubbles: true,
              detail: { product: line, sections: r.data.sections, items: r.data.items, addToCartBtn: btn }
            }));
            if (!drawerSection || !document.getElementById('CartDrawer')) window.location.href = (routes.cartPage || '/cart');
          })
          .catch(function () { btn.classList.remove('is-loading'); self.fail(); });
      });
    });
  };

  Pdp.prototype.add = function () {
    var self = this, form = this.form, atc = this.atc;
    if (this.busy || !this.variant || !this.variant.available) return;
    this.busy = true;
    $$(this.root, '[data-upp-error]').forEach(function (err) { err.hidden = true; err.textContent = ''; });
    var busyBtns = [atc, this.sgAtc].filter(Boolean);
    busyBtns.forEach(function (b) { b.classList.add('is-loading'); });

    var items = [{ id: this.variant.id, quantity: this.qty() }];
    var chairs = this.setOn() ? this.chairCount() : 0;
    if (chairs) items.push({ id: this.data.set.variantId, quantity: chairs });
    /* Delivery add-ons (one choice per piece): the piece carries "Delivery" + _upp_link; Expedite adds
       the expedite product with the same qty (_upp_for = that link), White glove adds one order line
       (_upp_wg). assets/upp-cart.js keeps them in step when lines change or go. */
    var opt = this.deliveryOption(), addons = this.data.addons || {};
    if ((opt === 'exp' && addons.exp) || (opt === 'wg' && addons.wg)) {
      var link = 'u' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
      var name = String(($(this.root, '.upp-pdp__title') || {}).textContent || '').split(',')[0].trim();
      items[0].properties = { 'Delivery': opt === 'exp' ? 'Expedited production' : 'White glove', '_upp_link': link };
      if (opt === 'exp') items.push({ id: addons.exp, quantity: items[0].quantity, properties: { '_upp_for': link, 'For': name } });
      else items.push({ id: addons.wg, quantity: 1, properties: { '_upp_wg': '1' } });
    }
    var body = { items: items };
    var drawerSection = window.theme && theme.cart && theme.cart.drawerSection;
    if (drawerSection) { body.sections = drawerSection; body.sections_url = window.location.pathname; }

    form.dispatchEvent(new CustomEvent('ajaxProduct:adding', { bubbles: true }));

    var routes = (window.theme && theme.routes) || {};
    var url = routes.cartAdd || '/cart/add.js';
    if (!/\.js$/.test(url)) url += '.js';

    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        self.busy = false;
        busyBtns.forEach(function (b) { b.classList.remove('is-loading'); });
        if (!r.ok || r.data.status) {
          self.fail(r.data && (r.data.description || r.data.message));
          return;
        }
        // Listeners expect one line item (theme.AjaxProduct posts a single id): pass the main
        // line, named "<product> + N chairs" when the set was added, with the drawer sections.
        var line = Object.assign({}, (r.data.items && r.data.items[0]) || {});
        if (chairs && line.product_title) {
          line.product_title = String(line.product_title).split(',')[0].trim() + ' + ' + chairs + ' chairs';
        }
        line.sections = r.data.sections;
        form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: { product: line, sections: r.data.sections, items: r.data.items, addToCartBtn: atc }
        }));
        if (!drawerSection || !document.getElementById('CartDrawer')) {
          // No drawer on this page: go to the cart like a plain form post would.
          window.location.href = (routes.cartPage || '/cart');
        }
      })
      .catch(function () {
        self.busy = false;
        busyBtns.forEach(function (b) { b.classList.remove('is-loading'); });
        self.fail();
      });
  };

  Pdp.prototype.fail = function (msg) {
    document.dispatchEvent(new CustomEvent('ajaxProduct:addFailed'));
    $$(this.root, '[data-upp-error]').forEach(function (err) {
      err.textContent = typeof msg === 'string' && msg ? msg : 'Sorry, this could not be added to your cart. Please try again or call us.';
      err.hidden = false;
    });
  };

  /* ---------- Gallery ---------- */
  Pdp.prototype.initGallery = function () {
    var self = this, g = $(this.root, '[data-upp-gallery]');
    if (!g) return;
    this.track = $(g, '[data-upp-track]');
    this.slides = $$(g, '[data-upp-slide]');
    this.thumbs = $$(g, '[data-upp-thumb]');
    this.count = $(g, '[data-upp-count]');
    this.prev = $(g, '[data-upp-prev]');
    this.next = $(g, '[data-upp-next]');
    this.index = 0;
    if (!this.track || !this.slides.length) return;

    var raf = 0;
    this.track.addEventListener('scroll', function () {
      if (raf) return;
      raf = window.requestAnimationFrame(function () {
        raf = 0;
        var w = self.track.clientWidth || 1;
        self.setIndex(Math.round(self.track.scrollLeft / w));
      });
    }, { passive: true });

    this.thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () { self.go(Number(btn.getAttribute('data-upp-thumb'))); });
    });
    if (this.prev) this.prev.addEventListener('click', function () { self.go(self.index - 1); });
    if (this.next) this.next.addEventListener('click', function () { self.go(self.index + 1); });
    this.track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); self.go(self.index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(self.index - 1); }
    });

    // external videos load on tap
    $$(g, '[data-upp-play]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tpl = btn.parentNode.querySelector('template[data-upp-video]');
        if (!tpl) return;
        btn.replaceWith(tpl.content.cloneNode(true));
      });
    });

    // pause native videos that scroll away
    this.track.addEventListener('scroll', function () {
      $$(self.track, 'video').forEach(function (v) { if (!v.paused) { var r = v.getBoundingClientRect(), t = self.track.getBoundingClientRect(); if (r.right <= t.left + 1 || r.left >= t.right - 1) v.pause(); } });
    }, { passive: true });

    /* native gallery videos: one play/pause button in the middle (no browser control bar); a tap on the
       playing video pauses it too. The slide gets is-playing so the button hides while it plays. */
    g.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-upp-vtoggle]');
      var v = btn ? btn.parentNode.querySelector('video') : (e.target.matches && e.target.matches('video.upp-pdp-g__video') ? e.target : null);
      if (!v) return;
      e.preventDefault();
      if (v.paused) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else v.pause();
    });
    ['play', 'pause', 'ended'].forEach(function (type) {
      g.addEventListener(type, function (e) {
        var v = e.target;
        if (!v.matches || !v.matches('video.upp-pdp-g__video')) return;
        var on = !v.paused && !v.ended;
        var li = v.parentNode;
        li.classList.toggle('is-playing', on);
        var b = li.querySelector('[data-upp-vtoggle]');
        if (b) b.setAttribute('aria-label', on ? 'Pause video' : 'Play video');
      }, true);
    });

    // desktop grid: tiles after the 6th show on "Show more images"
    var more = $(g, '[data-upp-more]');
    /* gallery videos come as <template data-upp-later> so their posters don't load early:
       desktop fills the visible grid at once (the rest on "Show more"); phones fill a slide's video
       when the slide comes within one slide of view (IntersectionObserver on the track). */
    function fillOne(tpl) { if (tpl.parentNode) tpl.replaceWith(tpl.content.cloneNode(true)); }
    function fillLater() { $$(g, 'template[data-upp-later]').forEach(fillOne); }
    function fillVisibleGrid() {
      $$(g, 'template[data-upp-later]').forEach(function (tpl) {
        var li = tpl.closest('[data-upp-slide]');
        if (li && !li.classList.contains('upp-pdp-g__slide--more')) fillOne(tpl);
      });
    }
    function fillNearOnPhones() {
      if (!('IntersectionObserver' in window)) { fillLater(); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          io.unobserve(e.target);
          var tpl = $(e.target, 'template[data-upp-later]');
          if (tpl) fillOne(tpl);
        });
      }, { root: self.track, rootMargin: '0px 100% 0px 100%' });
      $$(g, 'template[data-upp-later]').forEach(function (tpl) { var li = tpl.closest('[data-upp-slide]'); if (li) io.observe(li); });
    }
    var phone = window.matchMedia('(max-width: 989px)');
    if (phone.matches) fillNearOnPhones(); else fillVisibleGrid();
    if (phone.addEventListener) phone.addEventListener('change', function (e) { if (e.matches) fillNearOnPhones(); else fillVisibleGrid(); });
    this.expandGallery = function () {
      if (!more || g.classList.contains('is-all')) return false;
      fillLater();
      g.classList.add('is-all');
      more.setAttribute('aria-expanded', 'true');
      return true;
    };
    /* Desktop: show more than 6 tiles when the buy box beside the gallery is taller (owner 2026-10-17).
       Tiles after the 6th are revealed in order while the grid is still shorter than the buy box (by more than
       40px), so the last one may run a little past the box instead of leaving a gap. Both columns start at the
       same top (grid row, align-items: start), so heights compare directly. Only ever reveals, never hides
       again; it runs at load, before anything below the fold is seen, and tiles have a fixed aspect ratio, so
       heights are known before their images load. Re-runs when the buy box grows (options, delivery lines). */
    var buy = $(this.root, '.upp-pdp__buy');
    var moreLabel = more ? more.firstChild : null;
    function sameRowSquare(li) {
      /* li would sit next to the tile before it (a square whose row has one empty half) */
      var prev = li.previousElementSibling;
      li.classList.remove('upp-pdp-g__slide--more');
      var same = prev && Math.abs(li.offsetTop - prev.offsetTop) < 2;
      li.classList.add('upp-pdp-g__slide--more');
      return same;
    }
    function fitToBuy() {
      if (!more || !buy || !self.track || phone.matches || g.classList.contains('is-all')) return;
      var limit = buy.offsetHeight;
      var rest = $$(g, '.upp-pdp-g__slide--more');
      var shown = 0;
      for (var i = 0; i < rest.length; i++) {
        var li = rest[i];
        /* a square that completes a row adds no height, so it always comes along */
        if (self.track.offsetHeight >= limit - 40 && !(li.previousElementSibling && !li.previousElementSibling.classList.contains('upp-pdp-g__slide--more') && sameRowSquare(li))) break;
        li.classList.remove('upp-pdp-g__slide--more');
        var tpl = $(li, 'template[data-upp-later]');
        if (tpl) fillOne(tpl);
        shown++;
      }
      if (!shown) return;
      var left = rest.length - shown;
      if (!left) { g.classList.add('is-all'); more.setAttribute('aria-expanded', 'true'); }
      else if (moreLabel && moreLabel.nodeType === 3) moreLabel.nodeValue = moreLabel.nodeValue.replace(/\(\d+\)/, '(' + left + ')');
    }
    fitToBuy();
    if (buy && 'ResizeObserver' in window) new ResizeObserver(fitToBuy).observe(buy);

    if (more) more.addEventListener('click', function () {
      self.expandGallery();
      var first = $(g, '.upp-pdp-g__slide--more');
      var target = first && first.querySelector('button, video, iframe');
      if (first && !target) { first.tabIndex = -1; target = first; }
      if (target) target.focus();
    });

    this.initZoom(g);
    var start = this.variant ? this.variant.media : null;
    if (start) this.showMedia(start, true);
  };

  Pdp.prototype.setIndex = function (i) {
    if (!this.slides) return;
    i = Math.max(0, Math.min(this.slides.length - 1, i));
    this.index = i;
    if (this.count) this.count.textContent = i + 1;
    if (this.prev) this.prev.disabled = i === 0;
    if (this.next) this.next.disabled = i === this.slides.length - 1;
    this.thumbs.forEach(function (t) {
      var on = Number(t.getAttribute('data-upp-thumb')) === i;
      if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
    });
    var active = this.thumbs[i];
    if (active && active.parentNode && active.parentNode.parentNode) {
      var list = active.parentNode.parentNode, li = active.parentNode;
      var vertical = list.scrollHeight > list.clientHeight + 2 && getComputedStyle(list).flexDirection === 'column';
      if (vertical) {
        if (li.offsetTop < list.scrollTop || li.offsetTop + li.offsetHeight > list.scrollTop + list.clientHeight) list.scrollTop = li.offsetTop - 8;
      } else if (li.offsetLeft < list.scrollLeft || li.offsetLeft + li.offsetWidth > list.scrollLeft + list.clientWidth) {
        list.scrollLeft = li.offsetLeft - 16;
      }
    }
  };

  Pdp.prototype.go = function (i, instant) {
    if (!this.track) return;
    i = Math.max(0, Math.min(this.slides.length - 1, i));
    var left = this.slides[i].offsetLeft - this.slides[0].offsetLeft;
    if (instant) {
      var prevBehavior = this.track.style.scrollBehavior;
      this.track.style.scrollBehavior = 'auto';
      this.track.scrollLeft = left;
      this.track.style.scrollBehavior = prevBehavior;
    } else {
      this.track.scrollTo({ left: left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    this.setIndex(i);
  };

  Pdp.prototype.showMedia = function (mediaId, instant) {
    if (!mediaId || !this.slides) return;
    /* a size chip on the drawing slide: stay on the drawing */
    if (this.holdMedia) return;
    /* Desktop grid: nothing to scroll to, but open the collapsed tiles if the variant's image is among them. */
    if (window.matchMedia('(min-width: 990px)').matches) {
      var hit = this.slides.filter(function (s) { return Number(s.getAttribute('data-media-id')) === mediaId; })[0];
      if (hit && hit.classList.contains('upp-pdp-g__slide--more') && this.expandGallery) this.expandGallery();
      return;
    }
    for (var i = 0; i < this.slides.length; i++) {
      if (Number(this.slides[i].getAttribute('data-media-id')) === mediaId) { if (i !== this.index) this.go(i, instant); return; }
    }
  };

  /* ---------- Zoom viewer ----------
     2026-10-27 (owner: the IWA / CFW zoom, kept in UPP's look). Every photo and the dimensions drawing in gallery
     order (videos stay out), side by side in one track moved by transform: a swipe, the arrows, the arrow keys or a
     thumbnail changes the item; a pinch, a double tap, the bar's zoom button or a mouse click zooms a photo in at that
     point (2.5x, at least 2x when the file is small; pinch up to 4x or the file's size); a zoomed photo pans under the finger or the
     mouse and the swipe waits until it is zoomed out. The stage is touch-action: none, so the page never pinch-zooms
     behind it. The drawing is a page: a copy of the gallery figure without data-upp-dw, ids or listeners (the size
     code leaves it alone), copied again whenever the original changes; a chip in it clicks the original's chip, so
     the variant, price and URL follow the usual path. The selling points over a photo come under it here. Slides and
     thumbnails are built on the first open; each photo loads its 2000px file when it or a neighbour is shown, over
     the gallery's own copy. */
  Pdp.prototype.initZoom = function (g) {
    var self = this, dlg = $(g, '[data-upp-zoom-dialog]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    var stage = $(dlg, '[data-upp-zoom-stage]'), track = $(dlg, '[data-upp-zoom-track]'), strip = $(dlg, '[data-upp-zoom-thumbs]');
    var count = $(dlg, '[data-upp-zoom-count]'), toggle = $(dlg, '[data-upp-zoom-toggle]');
    var prev = $(dlg, '[data-upp-zoom-prev]'), next = $(dlg, '[data-upp-zoom-next]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var TAP = 2.5, MAX = 4;
    var items = [], at = 0, built = false, opener = null, resetT = 0;
    this.slides.forEach(function (s) {
      var btn = s.querySelector('[data-upp-zoom]');
      if (btn) items.push({ slide: s, btn: btn, kind: 'image' });
      else if (s.getAttribute('data-kind') === 'drawing' && s.querySelector('[data-upp-dw]')) items.push({ slide: s, kind: 'page', src: s.querySelector('[data-upp-dw]') });
    });
    if (!items.some(function (it) { return it.kind === 'image'; })) return;

    function caption(slide) {
      var pts = $$(slide, '.upp-pdp-pts li');
      if (!pts.length) return null;
      var ul = document.createElement('ul');
      ul.className = 'upp-pdp-zoom__cap';
      ul.setAttribute('role', 'list');
      pts.forEach(function (p) { var li = document.createElement('li'); li.textContent = p.textContent; ul.appendChild(li); });
      return ul;
    }
    function copyPage(it) {
      var c = it.src.cloneNode(true);
      c.removeAttribute('data-upp-dw');
      $$(c, '[id]').forEach(function (n) { n.removeAttribute('id'); });
      $$(c, '[aria-labelledby]').forEach(function (n) { n.removeAttribute('aria-labelledby'); });
      $$(c, '[data-upp-lazy]').forEach(function (im) { if (!im.getAttribute('href')) im.setAttribute('href', im.getAttribute('data-src')); });
      $$(c, '.upp-pdp-dw__chip').forEach(function (b, i) { b.setAttribute('data-upp-zoom-chip', i); });
      it.sheet.textContent = '';
      it.sheet.appendChild(c);
      /* a chip row wider than the page: the picked chip in the middle */
      $$(c, '.upp-pdp-dw__chips').forEach(function (row) {
        var on = $(row, '[aria-pressed="true"]');
        if (on && row.scrollWidth > row.clientWidth) row.scrollLeft += on.getBoundingClientRect().left - row.getBoundingClientRect().left - (row.clientWidth - on.offsetWidth) / 2;
      });
    }
    function watchPages(on) {
      items.forEach(function (it) {
        if (it.kind !== 'page' || !('MutationObserver' in window)) return;
        if (on && !it.obs) {
          var raf = 0;
          it.obs = new MutationObserver(function () {
            if (raf) return;
            raf = window.requestAnimationFrame(function () { raf = 0; copyPage(it); });
          });
          it.obs.observe(it.src, { subtree: true, childList: true, attributes: true, characterData: true });
        } else if (!on && it.obs) {
          it.obs.disconnect();
          it.obs = null;
        }
      });
    }
    function build() {
      built = true;
      items.forEach(function (it, k) {
        var li = document.createElement('li');
        li.className = 'upp-pdp-zoom__slide';
        if (it.kind === 'image') {
          var small = it.btn.querySelector('img'), frame = document.createElement('div'), img = document.createElement('img');
          var w = small ? Number(small.getAttribute('width')) : 0, h = small ? Number(small.getAttribute('height')) : 0;
          it.ratio = w && h ? w / h : 1;
          it.z = { s: 1, x: 0, y: 0 };
          frame.className = 'upp-pdp-zoom__frame';
          img.className = 'upp-pdp-zoom__img';
          img.alt = small ? small.alt : '';
          img.decoding = 'async';
          img.draggable = false;
          img.addEventListener('load', function () {
            img.style.backgroundImage = '';
            if (!img.naturalWidth) return;
            it.nw = img.naturalWidth;
            var r = img.naturalWidth / img.naturalHeight;
            if (Math.abs(r - it.ratio) > 0.01) { it.ratio = r; fit(it); }
          });
          frame.appendChild(img);
          li.appendChild(frame);
          var cap = caption(it.slide);
          if (cap) li.appendChild(cap);
          it.small = small;
          it.frame = frame;
          it.img = img;
        } else {
          var pg = document.createElement('div'), sheet = document.createElement('div');
          pg.className = 'upp-pdp-zoom__page';
          sheet.className = 'upp-pdp-zoom__sheet';
          pg.appendChild(sheet);
          li.appendChild(pg);
          it.frame = pg;
          it.sheet = sheet;
          sheet.addEventListener('click', function (e) {
            var c = e.target.closest('[data-upp-zoom-chip]');
            var real = c && $$(it.src, '.upp-pdp-dw__chip')[Number(c.getAttribute('data-upp-zoom-chip'))];
            if (real) real.click();
          });
        }
        it.li = li;
        track.appendChild(li);
        /* thumbnail: the gallery's own (photo or "Dimensions"), numbered for the viewer */
        var src = $(g, '[data-upp-thumb="' + it.slide.getAttribute('data-index') + '"]');
        var tli = document.createElement('li'), b = document.createElement('button');
        b.type = 'button';
        b.className = src ? src.className : 'upp-pdp-g__thumb';
        if (src) b.innerHTML = src.innerHTML;
        b.setAttribute('aria-label', it.kind === 'page' && src ? src.getAttribute('aria-label') : 'Show image ' + (k + 1) + ' of ' + items.length);
        b.addEventListener('click', function () { go(k, true); });
        tli.appendChild(b);
        strip.appendChild(tli);
        it.thumb = b;
      });
      var one = items.length < 2;
      strip.hidden = one;
      count.hidden = one;
      prev.hidden = one;
      next.hidden = one;
    }

    /* zoom state per photo: s = scale of the fitted size, x / y = top left of the scaled photo in its frame */
    function bounds(it, s) {
      var w = it.fw * s, h = it.fh * s;
      return {
        x0: w <= it.W ? (it.W - w) / 2 : it.W - w, x1: w <= it.W ? (it.W - w) / 2 : 0,
        y0: h <= it.H ? (it.H - h) / 2 : it.H - h, y1: h <= it.H ? (it.H - h) / 2 : 0
      };
    }
    function clampZ(it, z) {
      var b = bounds(it, z.s);
      return { s: z.s, x: Math.min(b.x1, Math.max(b.x0, z.x)), y: Math.min(b.y1, Math.max(b.y0, z.y)) };
    }
    function maxS(it) { return Math.max(TAP, Math.min(MAX, (it.nw || 2000) / it.fw)); }
    function paint(it, anim) {
      it.img.style.transition = anim && !reduce.matches ? 'transform .25s ease-out' : 'none';
      it.img.style.transform = 'translate3d(' + it.z.x + 'px,' + it.z.y + 'px,0) scale(' + it.z.s + ')';
      if (it === items[at]) syncBar();
    }
    /* fit the photo in its frame; keep a zoom (resize, rotation) but bring it back inside */
    function fit(it) {
      if (it.kind !== 'image') return;
      var W = it.frame.clientWidth, H = it.frame.clientHeight;
      if (!W || !H) return;
      var keep = it.z.s > 1.01 && it.fw;
      var cx = keep ? (W / 2 - it.z.x) / (it.fw * it.z.s) : 0, cy = keep ? (H / 2 - it.z.y) / (it.fh * it.z.s) : 0;
      it.W = W;
      it.H = H;
      it.fw = Math.min(W, H * it.ratio);
      it.fh = it.fw / it.ratio;
      it.img.style.width = it.fw + 'px';
      it.img.style.height = it.fh + 'px';
      it.z = keep ? clampZ(it, { s: it.z.s, x: W / 2 - cx * it.fw * it.z.s, y: H / 2 - cy * it.fh * it.z.s }) : { s: 1, x: (W - it.fw) / 2, y: (H - it.fh) / 2 };
      paint(it, false);
    }
    function zoomTo(it, s, px, py, anim) {
      var ix = (px - it.z.x) / it.z.s, iy = (py - it.z.y) / it.z.s;
      it.z = clampZ(it, { s: s, x: px - ix * s, y: py - iy * s });
      paint(it, anim);
    }
    /* a tap or click: 2.5x, or on a big screen the file's own size when that is less, but at least 2x */
    function tapS(it) { return Math.max(2, Math.min(TAP, (it.nw || 2000) / it.fw)); }
    function tapZoom(it, px, py) { zoomTo(it, it.z.s > 1.01 ? 1 : tapS(it), px, py, true); }
    /* after a pinch or pan: scale back between 1 and the top, photo back inside its frame */
    function settle(it) {
      var s = Math.max(1, Math.min(maxS(it), it.z.s));
      zoomTo(it, s, it.W / 2, it.H / 2, true);
    }
    function syncBar() {
      var it = items[at], page = it.kind === 'page', on = !page && it.z.s > 1.01;
      dlg.classList.toggle('is-zoomed', on);
      dlg.classList.toggle('is-page', page);
      toggle.hidden = page;
      toggle.setAttribute('aria-pressed', on ? 'true' : 'false');
      toggle.setAttribute('aria-label', on ? 'Zoom out' : 'Zoom in');
    }

    function place(dx, anim) {
      track.style.transition = anim && !reduce.matches ? 'transform .3s ease-out' : 'none';
      track.style.transform = 'translate3d(' + (-at * stage.clientWidth + dx) + 'px,0,0)';
    }
    function load(k) {
      var it = items[k];
      if (!it || it.kind !== 'image' || it.img.getAttribute('src')) return;
      var cur = it.small && (it.small.currentSrc || it.small.getAttribute('src'));
      if (cur) it.img.style.backgroundImage = 'url("' + cur + '")';
      it.img.src = it.btn.getAttribute('data-zoom-src');
    }
    function showThumb(b) {
      var li = b.parentNode;
      if (getComputedStyle(strip).flexDirection === 'column') strip.scrollTop = li.offsetTop - (strip.clientHeight - li.offsetHeight) / 2;
      else strip.scrollLeft = li.offsetLeft - (strip.clientWidth - li.offsetWidth) / 2;
    }
    /* arrows at the middle of the shown photo (a caption under it makes its frame shorter than the stage) */
    function setMid() {
      var f = items[at].frame;
      stage.style.setProperty('--upp-zoom-mid', (f.offsetTop + f.offsetHeight / 2) + 'px');
    }
    function go(k, anim) {
      k = Math.max(0, Math.min(items.length - 1, k));
      var was = items[at];
      at = k;
      place(0, anim);
      /* photos left zoomed come back to fit once they are out of view */
      if (was !== items[k]) {
        window.clearTimeout(resetT);
        resetT = window.setTimeout(function () {
          items.forEach(function (it, i) { if (i !== at && it.kind === 'image' && it.z.s > 1.01) { it.z.s = 1; fit(it); } });
        }, anim ? 320 : 0);
      }
      items.forEach(function (it, i) {
        if (i === k) { it.li.removeAttribute('inert'); it.thumb.setAttribute('aria-current', 'true'); }
        else { it.li.setAttribute('inert', ''); it.thumb.removeAttribute('aria-current'); }
      });
      load(k);
      load(k + 1);
      load(k - 1);
      count.textContent = (k + 1) + ' / ' + items.length;
      prev.disabled = k === 0;
      next.disabled = k === items.length - 1;
      showThumb(items[k].thumb);
      setMid();
      syncBar();
    }
    function layout() {
      items.forEach(fit);
      place(0, false);
      setMid();
    }
    function open(k) {
      if (!built) build();
      items.forEach(function (it) { if (it.kind === 'page') copyPage(it); });
      watchPages(true);
      dlg.showModal();
      document.documentElement.style.overflow = 'hidden';
      items.forEach(function (it) { if (it.kind === 'image') it.z.s = 1; fit(it); });
      at = k;
      go(k, false);
    }

    items.forEach(function (it, k) {
      if (it.btn) it.btn.addEventListener('click', function (e) { opener = e.currentTarget; open(k); });
    });
    $(dlg, '[data-upp-zoom-close]').addEventListener('click', function () { dlg.close(); });
    prev.addEventListener('click', function () { go(at - 1, true); });
    next.addEventListener('click', function () { go(at + 1, true); });
    toggle.addEventListener('click', function () { var it = items[at]; if (it.kind === 'image') tapZoom(it, it.W / 2, it.H / 2); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(at + 1, true); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(at - 1, true); }
    });
    /* iOS: no page pinch behind the viewer */
    dlg.addEventListener('gesturestart', function (e) { e.preventDefault(); });
    if ('ResizeObserver' in window) new ResizeObserver(function () { if (dlg.open && built) layout(); }).observe(stage);

    /* gestures: one pointer swipes (or pans a zoomed photo), two pinch; a tap is a mouse click or half a double tap.
       Pointers that start on a button, link or the drawing's chip band are left to them. */
    var pts = {}, one = null, pinch = null, lastTap = null;
    function pair() { var k = Object.keys(pts); return [pts[k[0]], pts[k[1]]]; }
    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (e.target.closest('button, a, input, label, .upp-pdp-dw__under')) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      try { stage.setPointerCapture(e.pointerId); } catch (err) { /* already released */ }
      var it = items[at], n = Object.keys(pts).length;
      if (n === 1) {
        one = { id: e.pointerId, x: e.clientX, y: e.clientY, t: Date.now(), zx: it.z ? it.z.x : 0, zy: it.z ? it.z.y : 0, mode: '', type: e.pointerType };
      } else if (n === 2) {
        if (one && one.mode === 'swipe') place(0, true);
        one = null;
        dlg.classList.remove('is-dragging');
        if (it.kind !== 'image') return;
        var p = pair(), r = it.frame.getBoundingClientRect();
        var mx = (p[0].x + p[1].x) / 2 - r.left, my = (p[0].y + p[1].y) / 2 - r.top;
        pinch = { d: Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y) || 1, s: it.z.s, ix: (mx - it.z.x) / it.z.s, iy: (my - it.z.y) / it.z.s, r: r };
      }
    });
    stage.addEventListener('pointermove', function (e) {
      if (!pts[e.pointerId]) return;
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      var it = items[at];
      if (pinch) {
        if (Object.keys(pts).length < 2) return;
        var p = pair(), top = maxS(it);
        var s = pinch.s * Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y) / pinch.d;
        s = s < 1 ? 1 - (1 - s) / 3 : s > top ? top + (s - top) / 3 : s;
        it.z = { s: s, x: (p[0].x + p[1].x) / 2 - pinch.r.left - pinch.ix * s, y: (p[0].y + p[1].y) / 2 - pinch.r.top - pinch.iy * s };
        paint(it, false);
        return;
      }
      if (!one || one.id !== e.pointerId) return;
      var dx = e.clientX - one.x, dy = e.clientY - one.y;
      if (!one.mode) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        one.mode = it.kind === 'image' && it.z.s > 1.01 ? 'pan' : 'swipe';
        dlg.classList.add('is-dragging');
      }
      if (one.mode === 'pan') {
        var b = bounds(it, it.z.s), x = one.zx + dx, y = one.zy + dy;
        x = x > b.x1 ? b.x1 + (x - b.x1) / 3 : x < b.x0 ? b.x0 + (x - b.x0) / 3 : x;
        y = y > b.y1 ? b.y1 + (y - b.y1) / 3 : y < b.y0 ? b.y0 + (y - b.y0) / 3 : y;
        it.z = { s: it.z.s, x: x, y: y };
        paint(it, false);
      } else {
        place((at === 0 && dx > 0) || (at === items.length - 1 && dx < 0) ? dx / 3 : dx, false);
      }
    });
    function up(e) {
      if (!pts[e.pointerId]) return;
      delete pts[e.pointerId];
      var it = items[at];
      if (pinch) {
        /* the pinch ends with its first lifted finger; the other one does nothing until it lifts too */
        pinch = null;
        settle(it);
        return;
      }
      if (!one || one.id !== e.pointerId) return;
      var dx = e.clientX - one.x, dt = Date.now() - one.t, mode = one.mode, type = one.type;
      one = null;
      dlg.classList.remove('is-dragging');
      if (mode === 'swipe') {
        if (e.type !== 'pointercancel' && (Math.abs(dx) > stage.clientWidth * 0.15 || (Math.abs(dx) > 20 && Math.abs(dx) / Math.max(dt, 1) > 0.4))) go(at + (dx < 0 ? 1 : -1), true);
        else place(0, true);
        return;
      }
      if (mode === 'pan') { settle(it); return; }
      if (e.type === 'pointercancel' || it.kind !== 'image') return;
      var r = it.frame.getBoundingClientRect(), px = e.clientX - r.left, py = e.clientY - r.top, now = Date.now();
      if (type === 'mouse') { tapZoom(it, px, py); return; }
      if (lastTap && now - lastTap.t < 320 && Math.hypot(lastTap.x - px, lastTap.y - py) < 40) {
        lastTap = null;
        tapZoom(it, px, py);
      } else {
        lastTap = { t: now, x: px, y: py };
      }
    }
    stage.addEventListener('pointerup', up);
    stage.addEventListener('pointercancel', up);
    /* desktop: ctrl + wheel (a trackpad pinch) zooms, the wheel pans a zoomed photo */
    stage.addEventListener('wheel', function (e) {
      var it = items[at];
      if (it.kind !== 'image' || (!e.ctrlKey && it.z.s <= 1.01)) return;
      e.preventDefault();
      var r = it.frame.getBoundingClientRect();
      if (e.ctrlKey) zoomTo(it, Math.max(1, Math.min(maxS(it), it.z.s * Math.exp(-e.deltaY / 100))), e.clientX - r.left, e.clientY - r.top, false);
      else { it.z = clampZ(it, { s: it.z.s, x: it.z.x - e.deltaX, y: it.z.y - e.deltaY }); paint(it, false); }
    }, { passive: false });

    dlg.addEventListener('close', function () {
      document.documentElement.style.overflow = '';
      watchPages(false);
      pts = {};
      one = null;
      pinch = null;
      dlg.classList.remove('is-dragging');
      var it = items[at];
      if (it) self.go(self.slides.indexOf(it.slide), true);
      if (opener) {
        var o = it && it.btn;
        /* a tile still collapsed behind "Show more images" can't take focus */
        if (o && !o.offsetParent) o = null;
        (o || opener).focus({ preventScroll: true });
      }
    });
  };

  /* ---------- Sticky bar (phones) ---------- */
  Pdp.prototype.initBar = function () {
    var self = this, bar = $(this.root, '[data-upp-bar]');
    if (!bar || !this.atc || !('IntersectionObserver' in window)) return;
    bar.hidden = false;
    var btn = $(bar, '[data-upp-bar-btn]');
    btn.addEventListener('click', function () {
      /* Submit after this click has finished: submitting inside it opened the cart drawer, whose
         outside-click close then caught the same click (the bar is outside the drawer), so the drawer
         opened, closed and opened again (owner 2026-10-17). */
      window.setTimeout(function () {
        if (self.form.requestSubmit) self.form.requestSubmit(self.atc);
        else self.atc.click();
      }, 0);
    });
    /* all widths since 2026-10-16 (desktop: along the bottom, see upp-pdp.css) */
    var mq = window.matchMedia('(max-width: 989px)');
    var past = false;
    function apply() {
      var on = past;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      btn.tabIndex = on ? 0 : -1;
      document.documentElement.classList.toggle('upp-pdp-bar-on', on);
      if (on) document.documentElement.style.setProperty('--upp-pdp-bar-h', bar.offsetHeight + 'px');
    }
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      /* Show the bar whenever the main button is out of view: below the fold on first load
         (phones) as well as after scrolling past it. */
      past = !e.isIntersecting;
      apply();
    }).observe(this.atc);
    if (mq.addEventListener) mq.addEventListener('change', apply);
    apply();
  };

  /* ---------- Recently viewed (theme section) ---------- */
  Pdp.prototype.recordRecent = function () {
    try {
      var r = this.root, handle = r.getAttribute('data-product-handle');
      if (!handle) return;
      var store = window.theme && theme.recentlyViewed ? theme.recentlyViewed.recent : JSON.parse(localStorage.getItem('theme-recent') || '{}');
      delete store[handle];
      store[handle] = { url: r.getAttribute('data-product-url'), aspectRatio: r.getAttribute('data-aspect-ratio'), featuredImage: r.getAttribute('data-img-url') };
      localStorage.setItem('theme-recent', JSON.stringify(store));
    } catch (e) { /* storage blocked */ }
  };

  function boot() {
    $$(document, '[data-upp-pdp]').forEach(function (root) {
      if (root.__uppPdp) return;
      root.__uppPdp = new Pdp(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
